!(function(e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define('embross-device-manager', [], t)
    : 'object' == typeof exports
    ? (exports['embross-device-manager'] = t())
    : (e['embross-device-manager'] = t());
})(this, function() {
  if (typeof self !== 'undefined') {
    return (function(e) {
      function t(i) {
        if (s[i]) {
          return s[i].exports;
        }
        var n = (s[i] = { exports: {}, id: i, loaded: !1 });
        return e[i].call(n.exports, n, n.exports, t), (n.loaded = !0), n.exports;
      }

      var s = {};
      return (t.m = e), (t.c = s), (t.p = ''), t(0);
    })([
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.DeviceStatus = t.FingerPrintScannerErrors = t.SessionInfoEventType = t.EnvInfoEventType = t.IrisCameraLanguages = t.CardReaderEnableType = t.HostInterfaceEventType = t.transactionStateEvent = t.AppStateEventType = t.ScreenFlowEventType = t.ScreenInteractionEventType = t.RETURN_PROMISE = t.TraceLevels = t.deviceIds = t.TSDManager = t.OutOfServiceManager = t.AppManager = t.DeviceManager = void 0);
        var n = s(1),
          a = i(n),
          r = s(3),
          o = i(r),
          c = s(33),
          l = i(c),
          u = s(39),
          d = i(u),
          h = s(2),
          v = s(34),
          T = i(v);
        (t.DeviceManager = a.default),
          (t.AppManager = o.default),
          (t.OutOfServiceManager = l.default),
          (t.TSDManager = d.default),
          (t.deviceIds = h.deviceIds),
          (t.TraceLevels = h.TraceLevels),
          (t.RETURN_PROMISE = h.RETURN_PROMISE),
          (t.ScreenInteractionEventType = h.ScreenInteractionEventType),
          (t.ScreenFlowEventType = h.ScreenFlowEventType),
          (t.AppStateEventType = h.AppStateEventType),
          (t.transactionStateEvent = h.transactionStateEvent),
          (t.HostInterfaceEventType = h.HostInterfaceEventType),
          (t.CardReaderEnableType = h.CardReaderEnableType),
          (t.IrisCameraLanguages = h.IrisCameraLanguages),
          (t.EnvInfoEventType = h.EnvInfoEventType),
          (t.SessionInfoEventType = h.SessionInfoEventType),
          (t.FingerPrintScannerErrors = h.FingerPrintScannerErrors),
          (t.DeviceStatus = T.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var a = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          r = s(2),
          o = s(3),
          c = i(o),
          l = s(8),
          u = i(l),
          d = s(9),
          h = i(d),
          v = s(11),
          T = i(v),
          p = s(13),
          f = i(p),
          g = s(15),
          E = i(g),
          L = s(17),
          y = i(L),
          _ = s(19),
          A = i(_),
          O = s(21),
          m = i(O),
          R = s(23),
          I = i(R),
          S = s(25),
          b = i(S),
          C = s(27),
          k = i(C),
          M = s(29),
          D = i(M),
          G = s(31),
          P = i(G),
          w = s(6),
          N = (function() {
            function e(t, s, i) {
              var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : '';
              n(this, e),
                (this.appManager = null),
                (this.devices = []),
                (this.wsCallback = this.wsCallback.bind(this)),
                (this.getMaxTraceLevel = this.getMaxTraceLevel.bind(this)),
                (this.onConnected = null),
                (this.loggerSet = !1),
                (this.dmLoggerSet = !1),
                (this.maxTraceLevelToSend = r.TraceLevels.LOG_SECURE),
                (this.maxLogLthToSend = 1e3),
                (this.addTimeToTrace = !0),
                (this.noWebsocket = i),
                (this.maxMessagesToBuffer = 100),
                (this.logBuffer = []),
                (this.dmLog = this.dmLog.bind(this)),
                (this.logMemoryUsageFlag = !1),
                (this.socket = new u.default(t, s, this.wsCallback, this.getMaxTraceLevel, i, this.dmLog)),
                (this.defaultLoc = a),
                (this.TSDMan = null),
                (this.onReqDeviceOK = null),
                (this.promiseTimeout = 1e3),
                (this.defaultKioskId = r.KIOSK_ID_DEFAULT),
                this.dmLog(r.TraceLevels.LOG_SYSTEM, '***** DeviceManager ver: ' + this.getVersion()),
                this.dmLog(r.TraceLevels.LOG_SYSTEM, '***** DeviceManager build date: ' + this.getBuildDate()),
                this.dmLog(r.TraceLevels.LOG_SYSTEM, '***** Browser: ' + navigator.appVersion);
            }

            return (
              a(e, [
                {
                  key: 'wsCallback',
                  value: function(e) {
                    this.dmLog(r.TraceLevels.LOG_SYSTEM, 'socket callback event: ' + e.type),
                      'open' === e.type &&
                        null !== this.onConnected &&
                        (this.onConnected(), this.setLogger(r.DM_LOG, !1) && (this.dmLoggerSet = !0));
                  },
                },
                {
                  key: 'addDevices',
                  value: function(e, t, s) {
                    switch (e) {
                      case r.deviceIds.BARCODE_READER:
                        var i = new h.default(this.socket, this);
                        (i.OnDeviceEvent = t),
                          (i.IsRequired = s),
                          i.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(i);
                        break;
                      case r.deviceIds.CARD_READER:
                        var n = new T.default(this.socket, this);
                        (n.OnDeviceEvent = t),
                          (n.IsRequired = s),
                          n.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(n);
                        break;
                      case r.deviceIds.PASSPORT_READER:
                        var a = new f.default(this.socket, this);
                        (a.OnDeviceEvent = t),
                          (a.IsRequired = s),
                          a.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(a);
                        break;
                      case r.deviceIds.ATB_PRINTER:
                        var o = new E.default(this.socket, this);
                        (o.OnDeviceEvent = t),
                          (o.IsRequired = s),
                          o.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(o);
                        break;
                      case r.deviceIds.BAGTAG_PRINTER:
                        var c = new y.default(this.socket, this);
                        (c.OnDeviceEvent = t),
                          (c.IsRequired = s),
                          c.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(c);
                        break;
                      case r.deviceIds.AEA_BAGDROP:
                        var l = new m.default(this.socket, this);
                        (l.OnDeviceEvent = t),
                          (l.IsRequired = s),
                          l.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(l);
                        break;
                      case r.deviceIds.BAG_CONVEYOR:
                        break;
                      case r.deviceIds.DISPENSER:
                        break;
                      case r.deviceIds.CUSS_ACCESSIBILITY:
                        var u = new A.default(this.socket, this);
                        (u.OnDeviceEvent = t),
                          (u.IsRequired = s),
                          u.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(u);
                        break;
                      case r.deviceIds.FACE_TRACKING:
                        var d = new I.default(this.socket, this);
                        (d.OnDeviceEvent = t),
                          (d.IsRequired = s),
                          d.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(d);
                        break;
                      case r.deviceIds.LASER_PRINTER:
                        var v = new b.default(this.socket, this);
                        (v.OnDeviceEvent = t),
                          (v.IsRequired = s),
                          v.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(v);
                        break;
                      case r.deviceIds.FINGERPRINT_SCANNER:
                        var p = new k.default(this.socket, this);
                        (p.OnDeviceEvent = t),
                          (p.IsRequired = s),
                          p.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(p);
                        break;
                      case r.deviceIds.IRIS_CAMERA:
                        var g = new D.default(this.socket, this);
                        (g.OnDeviceEvent = t),
                          (g.IsRequired = s),
                          g.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(g);
                        break;
                      case r.deviceIds.EGATE:
                        var L = new P.default(this.socket, this);
                        (L.OnDeviceEvent = t),
                          (L.IsRequired = s),
                          L.setPromiseTimeout(this.promiseTimeout),
                          this.devices.push(L);
                    }
                  },
                },
                {
                  key: 'setAppManager',
                  value: function(e, t, s) {
                    var i = new c.default(this.socket, this);
                    (i.OnChange = e),
                      (i.OnActive = t),
                      (i.OnDeviceEvent = s),
                      i.setPromiseTimeout(this.promiseTimeout),
                      (this.appManager = i);
                  },
                },
                {
                  key: 'connect',
                  value: function() {
                    if (this.noWebsocket === !0) {
                      console.log('DeviceManager::connect(): noWebsocket.'),
                        this.onConnected(),
                        (this.appManager.kioskId = 'YYZTEST'),
                        (this.appManager.cussKioskId = r.KIOSK_ID_DEFAULT),
                        (this.appManager.smKioskId = r.KIOSK_ID_DEFAULT),
                        (this.appManager.location = this.defaultLoc ? this.defaultLoc : r.LOCATION_DEFAULT),
                        (this.appManager.airportCode = this.defaultLoc ? this.defaultLoc : r.LOCATION_DEFAULT);
                      for (var e = 0; e < this.devices.length; e++) {
                        this.devices[e].isDeviceOk = !0;
                      }
                      this.appManager.onSocketOpened();
                    } else {
                      this.socket.open(),
                        this.socket.isOpened
                          ? this.dmLog(r.TraceLevels.LOG_SYSTEM, 'DeviceManager::connect(): CUSS Applink is connected.')
                          : this.dmLog(
                              r.TraceLevels.LOG_SYSTEM,
                              'DeviceManager::connect(): CUSS Applink is not connected yet.'
                            );
                    }
                  },
                },
                {
                  key: 'isConnected',
                  value: function() {
                    return this.socket.isOpened;
                  },
                },
                {
                  key: 'getDevice',
                  value: function(e) {
                    var t = null;
                    return (
                      this.devices.map(function(s) {
                        s.deviceId === e && (t = s);
                      }),
                      t
                    );
                  },
                },
                {
                  key: 'getAppManager',
                  value: function() {
                    return this.appManager;
                  },
                },
                {
                  key: 'setLogger',
                  value: function(e, t) {
                    return this.socket.isOpened
                      ? (this.socket.sendCommand(r.deviceIds.LOGGER, 'setLogger', e, t), (this.loggerSet = !0), !0)
                      : this.noWebsocket === !0
                      ? (console.log('setLogger - emulation'), !0)
                      : (console.log('setLogger - socket is not opened'), !1);
                  },
                },
                {
                  key: 'sendLogMsg',
                  value: function(e, t) {
                    return this.socket.isOpened
                      ? (Array.isArray(t)
                          ? this.socket.sendCommand(r.deviceIds.LOGGER, 'logs', e, t)
                          : this.socket.sendCommand(r.deviceIds.LOGGER, 'log', e, t),
                        !0)
                      : this.noWebsocket === !0
                      ? (console.log('sendLogMsg: ' + t), !0)
                      : (this.dmLog(e, 'sendLogMsg (socket is not opened) AppMsg: ' + t), !1);
                  },
                },
                {
                  key: 'isLoggerSet',
                  value: function() {
                    return this.loggerSet;
                  },
                },
                {
                  key: 'setMaxTraceLevel',
                  value: function(e) {
                    this.maxTraceLevelToSend = e;
                  },
                },
                {
                  key: 'getMaxTraceLevel',
                  value: function() {
                    return this.maxTraceLevelToSend;
                  },
                },
                {
                  key: 'setMaxLogLth',
                  value: function(e) {
                    (0, w.isInteger)(e) && (this.maxLogLthToSend = e);
                  },
                },
                {
                  key: 'setAddTimeToTrace',
                  value: function(e) {
                    this.addTimeToTrace = e;
                  },
                },
                {
                  key: 'setMaxMessagesToBuffer',
                  value: function(e) {
                    (0, w.isInteger)(e) && (this.maxMessagesToBuffer = e);
                  },
                },
                {
                  key: 'setDefaultTimeout',
                  value: function(e) {
                    (0, w.isInteger)(e) && this.socket && this.socket.setDefaultTimeout(e);
                  },
                },
                {
                  key: 'setPromiseTimeout',
                  value: function(e) {
                    this.promiseTimeout = e;
                  },
                },
                {
                  key: 'areAllRequiredDevicesOK',
                  value: function(e) {
                    for (
                      var t = !0, s = 0;
                      s < this.devices.length &&
                      (this.dmLog(
                        r.TraceLevels.LOG_SYSTEM,
                        'areAllRequiredDevicesOK name: ' +
                          this.devices[s].name +
                          ' isRequired: ' +
                          this.devices[s].isRequired +
                          ' isDeviceOk: ' +
                          this.devices[s].isDeviceOk
                      ),
                      !this.devices[s].isRequired || this.devices[s].isDeviceOk || ((t = !1), e));
                      s++
                    ) {}
                    return t;
                  },
                },
                {
                  key: 'setTSDManager',
                  value: function(e) {
                    (this.TSDMan = e), this.TSDMan.setLogger(this.dmLog);
                  },
                },
                {
                  key: 'tsdDeviceEvent',
                  value: function(e, t, s, i) {
                    null != this.TSDMan && this.TSDMan.addDeviceInterEvent(e, t, s, i);
                  },
                },
                {
                  key: 'setOnRequiredDeviceOK',
                  value: function(e) {
                    this.onReqDeviceOK = e;
                  },
                },
                {
                  key: 'logMemoryUsage',
                  value: function() {
                    var e = 1048576;
                    this.logMemoryUsageFlag &&
                      window.performance &&
                      window.performance.memory &&
                      this.dmLog(
                        r.TraceLevels.LOG_EXT_TRACE,
                        '---> totalJSHeapSize: ' +
                          performance.memory.totalJSHeapSize / e +
                          ' usedJSHeapSize: ' +
                          performance.memory.usedJSHeapSize / e +
                          ' jsHeapSizeLimit: ' +
                          performance.memory.jsHeapSizeLimit / e
                      );
                  },
                },
                {
                  key: 'setLogMemoryUsage',
                  value: function(e) {
                    this.logMemoryUsageFlag = e;
                  },
                },
                {
                  key: 'dmLog',
                  value: function(e, t, s) {
                    e <= this.maxTraceLevelToSend &&
                      (t.length > this.maxLogLthToSend && (t = t.substring(0, this.maxLogLthToSend) + ' ...'),
                      this.isConnected() && this.dmLoggerSet
                        ? (this.logBuffer.length > 0 &&
                            (this.logBuffer.push((0, w.getTime)() + ' DM End of buffered messages:'),
                            this.socket.sendCommand(r.deviceIds.LOGGER, 'logs', r.DM_LOG, e, this.logBuffer),
                            (this.logBuffer.length = 0),
                            console.log('DM End of buffered messages.')),
                          this.addTimeToTrace
                            ? (t = (0, w.getTime)() + ' ' + t)
                            : s === !0 && (t = (0, w.getTime)() + ' ' + t),
                          this.socket.sendCommand(r.deviceIds.LOGGER, 'log', r.DM_LOG, e, t))
                        : this.maxMessagesToBuffer > 0
                        ? this.logBuffer.length < this.maxMessagesToBuffer
                          ? (0 === this.logBuffer.length &&
                              (this.logBuffer.push((0, w.getTime)() + ' DM Start of buffered messages:'),
                              console.log('DM Start of buffered messages.')),
                            this.logBuffer.push((0, w.getTime)() + ' ' + t))
                          : // ,console.log('DM BF: ' + t)
                          this.logBuffer.length === this.maxMessagesToBuffer
                          ? this.logBuffer.push((0, w.getTime)() + ' DM msg buffer exceeded!')
                          : // ,console.log('DM msg buffer exceeded!')
                            '' // console.log('DM no room to buffer: ' + t)
                        : ''); // console.log('DM dmlog: ' + t)
                  },
                },
                {
                  key: 'setDefaultKioskId',
                  value: function(e) {
                    this.defaultKioskId = e;
                  },
                },
                {
                  key: 'getVersion',
                  value: function() {
                    return '1.1.0';
                  },
                },
                {
                  key: 'getBuildDate',
                  value: function() {
                    return '"Fri Apr 12 2019 13:57:25 GMT-0400 (Eastern Daylight Time)"';
                  },
                },
              ]),
              e
            );
          })();
        (t.default = N), (e.exports = t.default);
      },
      function(e, t) {
        'use strict';
        Object.defineProperty(t, '__esModule', { value: !0 });
        (t.deviceIds = {
          WEBSOCKET_MANAGER: 100,
          CARD_READER: 0,
          ATB_PRINTER: 1,
          PASSPORT_READER: 2,
          BARCODE_READER: 3,
          BAGTAG_PRINTER: 4,
          APPLICATION_MANAGER: 5,
          SCREEN_MANAGER: 6,
          RECEIPT_PRINTER: 7,
          DISPENSER: 8,
          PIN_PAD: 9,
          LASER_PRINTER: 10,
          UPS: 11,
          IO_CONTROLLER: 12,
          GENERIC: 13,
          PAYMENT: 14,
          BAG_CONVEYOR: 15,
          FACE_CAMERA: 16,
          AEA_BAGDROP: 17,
          FINGERPRINT_SCANNER: 18,
          CUSS_ACCESSIBILITY: 19,
          FACE_TRACKING: 20,
          LED: 21,
          IRIS_CAMERA: 22,
          EGATE: 23,
          LOGGER: 99,
        }),
          (t.methods = {
            status: 1,
            isOK: 2,
            enable: 3,
            disable: 4,
            available: 5,
            initialize: 6,
            unavailable: 7,
            setState: 8,
            getKioskId: 10,
            getActualCUSSKioskId: 11,
            getSystemManagerKioskId: 12,
            getLocation: 13,
            getAirportCode: 14,
            getCurrentState: 15,
            sendApplicationLog: 20,
            sendApplicationStatusReasonIndicator: 21,
            sendApplicationStatusTransactionIndicator: 22,
            applicationTransfer: 23,
            sendAEA: 30,
            setupAEA: 31,
            read: 40,
            eject: 41,
            isDIP: 42,
            isSwipe: 43,
            isMotorized: 44,
            isMagneticStripe: 45,
            isCardInReader: 46,
            isCardPartiallyInserted: 47,
            capture: 48,
            isCardDispenser: 49,
            areAllBinsEmpty: 50,
            isTicketInHopper: 51,
            isTicketInPrinter: 52,
            isPECTABLoadedInPrinter: 53,
            loadPECTAB: 54,
            loadPECTABArray: 55,
            print: 56,
            printArray: 57,
            offer: 58,
            getBinsStatus: 59,
            isPassportInReader: 60,
            isPassportPartiallyInserted: 61,
            getStatusTTS: 62,
            getStatusKeypad: 63,
            getStatusHeadset: 64,
            blankDisplay: 65,
            showDisplay: 66,
            disableHeadset: 67,
            enableHeadset: 68,
            pause: 69,
            resume: 70,
            play: 71,
            stop: 72,
            resumeTouchScreen: 73,
            suppressTouchScreen: 74,
            isAccessibilitySupported: 75,
            isHeadsetAvailable: 76,
            isHeadsetInserted: 77,
            isKeypadAvailable: 78,
            isTTSAvailable: 79,
            getAvailableLanguages: 80,
            getDeviceHelpLanguages: 81,
            getKeypadEvents: 82,
            getKeypadType: 83,
            getKioskDeviceHelp: 84,
            getScreenDiagonal: 85,
            confirmAccessibleMode: 86,
            completeAccessibleMode: 87,
            disableKeypad: 88,
            enableKeypad: 89,
            disableTTS: 90,
            enableTTS: 91,
            isInAccessibleMode: 92,
            isPendingAccessibleMode: 93,
            setActiveWhenActive: 94,
            getHeadsetDeviceHelp: 95,
            getKeypadDeviceHelp: 96,
            printFileByteStream: 97,
            printPhotoStream: 98,
            printPDFStream: 99,
            statusIsOK: 100,
            show: 101,
            hide: 102,
            analyze: 103,
            clearSharedData: 104,
            write: 105,
            reset: 106,
            setup: 107,
            getCompanyCode: 108,
            getAppName: 109,
            toggleView: 110,
            switchView: 111,
            selectCamera: 112,
            setPaxId: 113,
            focusApp: 114,
            getVersion: 115,
            setDeviceLanguage: 120,
            getDeviceLanguage: 121,
            irisCameraCapture: 122,
            irisCameraEnroll: 123,
            irisCameraRecognize: 124,
            irisCameraDeleteDB: 125,
            openGate: 130,
            closeGate: 131,
            openGateForPax: 132,
            setDefaultLanguage: 180,
            getDefaultLanguage: 181,
            getConfig: 198,
            sendVersion: 199,
            setLogger: 200,
            log: 201,
            parse: 300,
            click: 301,
          }),
          (t.AppEvents = {
            socketOpened: 0,
            notifyActive: 1,
            notificationText: 2,
          }),
          (t.ActivationTypes = {
            APP_TOUCH: 0,
            CARD_SWIPE: 1,
            PASSPORT_SWIPE: 2,
            TICKET_INSERT: 3,
            UNKNOWN_ACTIVATION: -100,
          }),
          (t.TraceLevels = {
            LOG_SYSTEM: 0,
            LOG_ALERT: 1,
            LOG_LEVEL2: 2,
            LOG_TRACE: 3,
            LOG_LEVEL4: 4,
            LOG_EXT_TRACE: 5,
            LOG_LEVEL6: 6,
            LOG_SECURE: 7,
          }),
          (t.ApplicationState = {
            INITIALIZE: 1,
            UNAVAILABLE: 2,
            AVAILABLE: 3,
            ACTIVE: 4,
          }),
          (t.CardReaderEnableType = {
            NO_SETUP: 0,
            PAYMENT_ISO: 1,
            DISCRETIONARY_ISO: 2,
            FOID_ISO: 3,
            PAYMENT_JIS2: 4,
            DISCRETIONARY_JIS2: 5,
            FOID_JIS2: 6,
          }),
          (t.PromiseCodes = {
            RESOLVE: 0,
            REJECT: 1,
            TIMEOUT: 'Promise timeout',
            UNEXPECTED: 'Promise unexpected',
          }),
          (t.TSDTypes = {
            SCREEN_INTERACTION: 0,
            SCREEN_FLOW: 1,
            DEVICE_INTERACTION: 2,
            APPLICATION_STATE: 3,
            HOST_INTERFACE: 4,
            BUSINESS_FLOW: 5,
          }),
          (t.transactionStateEvent = {
            0: 'screenInteractionEvent',
            1: 'screenFlowEvent',
            2: 'deviceInteractionEvent',
            3: 'appStateEvent',
            4: 'hostInterfaceEvent',
            5: 'businessFlowEvent',
          }),
          (t.ScreenInteractionEventType = {
            ACTIVE_BUTTON_PRESSED: 'ACTIVE_BUTTON_PRESSED',
            BUTTON_ACTIVATED: 'BUTTON_ACTIVATED',
            NONINTERACTIVE_AREA_TOUCHED: 'NONINTERACTIVE_AREA_TOUCHED',
            INACTIVE_BUTTON_PRESSED: 'INACTIVE_BUTTON_PRESSED',
          }),
          (t.DeviceEventType = {
            OFFLINE: 'OFFLINE',
            ENABLED: 'ENABLED',
            DISABLED: 'DISABLED',
            MEDIA_INSERTED: 'MEDIA_INSERTED',
            MEDIA_REMOVED: 'MEDIA_REMOVED',
            MEDIA_DAMAGED: 'MEDIA_DAMAGED',
            DATA_READ: 'DATA_READ',
            JAMMED: 'JAMMED',
            OUT: 'OUT',
            NAVIGATION_KEY_PRESSED: 'NAVIGATION_KEY_PRESSED',
            INTRUSION: 'INTRUSION',
            HELP_LEVEL_INVOKED: 'HELP_LEVEL_INVOKED',
            HELP_LEVEL_PLAYED: 'HELP_LEVEL_PLAYED',
            HEADSET_INSERTED: 'HEADSET_INSERTED',
            HEADSET_REMOVED: 'HEADSET_REMOVED',
            PICTURE_TAKEN: 'PICTURE_TAKEN',
            PRINT_STARTED: 'PRINT_STARTED',
            PRINT_ENDED: 'PRINT_ENDED',
            EJECTED: 'EJECTED',
            LOADED: 'LOADED',
            PRESENT: 'PRESENT',
            PRINTED: 'PRINTED',
            STATUS_CHANGED: 'STATUS_CHANGED',
            DATA_ERROR: 'DATA_ERROR',
            FAILED: 'FAILED',
            INSERTED_INCOMPLETE: 'INSERTED_INCOMPLETE',
            ACCESSING_RF_CHIP: 'ACCESSING_RF_CHIP',
            FACE_DESCRIPTOR: 'FACE_DESCRIPTOR',
          }),
          (t.ScreenFlowEventType = {
            LOCAL_TRANSITION: 'LOCAL_TRANSITION',
            CONTROL_TRANSITION: 'CONTROL_TRANSITION',
            POPUP_START: 'POPUP_START',
            POPUP_END: 'POPUP_END',
            TIMEOUT: 'TIMEOUT',
          }),
          (t.AppStateEventType = {
            TXN_START: 'TXN_START',
            TXN_END: 'TXN_END',
            PLT_SESSION_TIMEOUT: 'PLT_SESSION_TIMEOUT',
            PLT_ACTIVE_STOPPED: 'PLT_ACTIVE_STOPPED',
            APP_AVAILABLE: 'APP_AVAILABLE',
            APP_UNAVAILABLE: 'APP_UNAVAILABLE',
            APP_ACTIVATED: 'APP_ACTIVATED',
            APP_DEACTIVATED: 'APP_DEACTIVATED',
          }),
          (t.HostInterfaceEventType = {
            REQUEST: 'REQUEST',
            RESPONSE: 'RESPONSE',
            EXCEPTION: 'EXCEPTION',
          }),
          (t.EnvInfoEventType = {
            OS_INFO: 'OS_INFO',
            CUSS_INFO: 'CUSS_INFO',
            APP_INFO: 'APP_INFO',
            CDS_INFO: 'CDS_INFO',
          }),
          (t.SessionInfoEventType = {
            SESSION_START: 'SESSION_START',
            SESSION_END: 'SESSION_END',
            CHKIN_SUMMARY: 'CHKIN_SUMMARY',
            SBD_SUMMARY: 'SBD_SUMMARY',
          }),
          (t.FingerPrintScannerErrors = {
            DATA_ERROR_FINGER_DO_NOT_FIT: 31,
            DATA_ERROR_NO_FINGERS_FOUND: 32,
            DATA_ERROR_WRONG_HAND: 33,
            DATA_ERROR_MISSING_FINGERS: 34,
            DATA_ERROR_NOTHING: 35,
            DATA_ERROR_UNIQNESS: 36,
            DATA_ERROR_SEQUENCE: 37,
            DATA_ERROR_QUALITY_CHECK: 38,
            DATA_ERROR_ROLL_WIDTH_RATIO: 39,
            DATA_ERROR_DISPLAY_GENERATION: 40,
            DATA_ERROR_IMAGE_GENERATION: 41,
            DATA_ERROR_API_CORE: 42,
            DATA_ERROR_API_PLUGIN: 43,
            DATA_ERROR_PROCESSING: 44,
            DATA_ERROR_TIMEOUT: 45,
            DATA_ERROR_ERROR_UNKNOWN: 46,
          }),
          (t.IrisCameraErrors = {}),
          (t.IrisCameraLanguages = {
            OTHER: 0,
            ENGLISH: 1,
            KOREAN: 2,
            CHINESE: 3,
            SPANISH: 4,
            ARABIC: 5,
            PORTUGUESE: 6,
            RUSSIAN: 7,
            GERMAN: 8,
            FRENCH: 9,
            TURKISH: 10,
            JAPANESE: 11,
            HINDI: 12,
          }),
          (t.DM_LOG = 'DevMan'),
          (t.KIOSK_ID_DEFAULT = 'KIOSKID'),
          (t.LOCATION_DEFAULT = 'LOC'),
          (t.RETURN_PROMISE = !0),
          (t.EventTypeName = {
            ENVIRONMENT_DETAILS: 'ENVIRONMENT_DETAILS',
            SESSION_SUMMARY_DETAILS: 'SESSION_SUMMARY_DETAILS',
            SCREEN_INTERACTION_EVENT_DETAILS: 'SCREEN_INTERACTION_EVENT_DETAILS',
            SCREEN_FLOW_EVENT_DETAILS: 'SCREEN_FLOW_EVENT_DETAILS',
            DEVICE_INTERACTION_EVENT_DETAILS: 'DEVICE_INTERACTION_EVENT_DETAILS',
            APP_STATE_EVENT_DETAILS: 'APP_STATE_EVENT_DETAILS',
            HOST_INTERFACE_EVENT_DETAILS: 'HOST_INTERFACE_EVENT_DETAILS',
            BUSINESS_FLOW_EVENT_DETAILS: 'BUSINESS_FLOW_EVENT_DETAILS',
          });
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(4),
          u = i(l),
          d = s(7),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.isActive = !1),
                (i.kioskId = null),
                (i.cussKioskId = null),
                (i.smKioskId = null),
                (i.location = null),
                (i.airportCode = null),
                (i.clientType = 'KIOSK'),
                (i.appVersion = ''),
                (i.locale = 'en'),
                (i.currentState = null),
                (i.status = null),
                (i.isOK = null),
                (i.name = 'Application Manager'),
                (i.accessibleMode = !1),
                (i.deviceId = c.deviceIds.APPLICATION_MANAGER),
                (i.listener = null),
                (i.onChange = null),
                (i.onActive = null),
                (i.onSocketOpened = null),
                i.setListener(new u.default()),
                i.socket.addListener(i.listener),
                (i.prom = null),
                (i.pTimer = null),
                (i.companyCode = null),
                (i.appName = null),
                (i.resetKioskAlert = !1),
                (i.kioskTypeId = ''),
                (i.kioskType = ''),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'initialize',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'AppManager.initialize()'),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'initialize');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'AppManager.initialize() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'available',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'send command available()'),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'available'),
                        this.dm.TSDMan && this.dm.TSDMan.addAppStateEvent(c.AppStateEventType.APP_AVAILABLE);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'available() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'unavailable',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'unavailable()'),
                        this.resetKioskAlert && this.kioskAlert('', !1),
                        (this.Active = !1),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'unavailable'),
                        this.dm.TSDMan && this.dm.TSDMan.addAppStateEvent(c.AppStateEventType.APP_UNAVAILABLE);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'unavailable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getKioskId',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getKioskID(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getKioskID');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getKioskID() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getSystemManagerKioskId',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getSystemManagerKioskID(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getSystemManagerKioskID');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getSystemManagerKioskID() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getLocation',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getLocation(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getLocation');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getLocation() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getActualCUSSKioskId',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getActualCUSSKioskID(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getActualCUSSKioskID');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getActualCUSSKioskID() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'sendApplicationLog',
                  value: function(e, t) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'sendApplicationLog(): ' + e + ', ' + t),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'sendApplicationLog', e, t);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'sendApplicationLog() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'appLighting',
                  value: function(e, t) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'appLighting(): ' + e + ', ' + t),
                        void 0 === e || 'OFF' === e
                          ? this.socket.sendCommand(
                              c.deviceIds.APPLICATION_MANAGER,
                              'sendApplicationLog',
                              100,
                              'CDS_APPLOG,LIGHTING,OFF'
                            )
                          : void 0 === t || 'OFF' === t
                          ? this.socket.sendCommand(
                              c.deviceIds.APPLICATION_MANAGER,
                              'sendApplicationLog',
                              100,
                              'CDS_APPLOG,LIGHTING,' + e + ',OFF'
                            )
                          : this.socket.sendCommand(
                              c.deviceIds.APPLICATION_MANAGER,
                              'sendApplicationLog',
                              100,
                              'CDS_APPLOG,LIGHTING,' + e + ',' + t
                            );
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'appLighting() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'kioskAlert',
                  value: function(e, t) {
                    this.logMessage(c.TraceLevels.LOG_TRACE, 'kioskAlert(): ' + e + ' on: ' + t),
                      t
                        ? this.socket.sendCommand(
                            c.deviceIds.APPLICATION_MANAGER,
                            'sendApplicationLog',
                            100,
                            'CDS_APPLOG,ALERT,' + e
                          )
                        : this.socket.sendCommand(
                            c.deviceIds.APPLICATION_MANAGER,
                            'sendApplicationLog',
                            100,
                            'CDS_APPLOG,ALERT,NO'
                          );
                  },
                },
                {
                  key: 'getAirportCode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getAirportCode(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getAirportCode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getAirportCode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setState',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'setState(): ' + e),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'setState', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setState() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getCurrentState',
                  value: function(e, t) {
                    var s = this;
                    try {
                      this.logMessage(
                        c.TraceLevels.LOG_TRACE,
                        'getCurrentState(): ' + (void 0 === e ? '' : e + ' ' + this.promiseTimeout)
                      );
                      var i = null;
                      if (
                        (e === !0 &&
                          (i =
                            null == this.prom
                              ? new Promise(function(e, t) {
                                  (s.prom = [e, t]),
                                    (s.pTimer = setTimeout(function() {
                                      s.prom &&
                                        (s.prom[c.PromiseCodes.REJECT](c.PromiseCodes.TIMEOUT), (s.prom = null));
                                    }, s.promiseTimeout));
                                })
                              : new Promise(function(e, t) {
                                  setTimeout(function() {
                                    t(c.PromiseCodes.UNEXPECTED);
                                  }, 10);
                                })),
                        t
                          ? setTimeout(function() {
                              s.prom[c.PromiseCodes.RESOLVE](c.ApplicationState.ACTIVE);
                            }, 10)
                          : this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getCurrentState'),
                        e === !0)
                      ) {
                        return i;
                      }
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getCurrentState() exception: ' + e);
                    }
                    return null;
                  },
                },
                {
                  key: 'confirmAccessibleMode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'confirmAccessibleMode(): '),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'confirmAccessibleMode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'confirmAccessibleMode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'completeAccessibleMode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'completeAccessibleMode(): '),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'completeAccessibleMode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'completeAccessibleMode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isPendingAccessibleMode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isPendingAccessibleMode(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'isPendingAccessibleMode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isPendingAccessibleMode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isInAccessibleMode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isInAccessibleMode(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'isInAccessibleMode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isInAccessibleMode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getCompanyCode',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getCompanyCode(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getCompanyCode');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getCompanyCode() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getAppName',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getAppName(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getAppName');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getAppName() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setActiveWhenActive',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'setActiveWhenActive(): '),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'setActiveWhenActive');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setActiveWhenActive() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setResetKioskAlert',
                  value: function(e) {
                    this.resetKioskAlert = e;
                  },
                },
                {
                  key: 'sendVersion',
                  value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'sendVersion(): ' + e),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'sendVersion', e, t);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'sendVersion() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getIsActive',
                  value: function() {
                    return this.isActive;
                  },
                },
                {
                  key: 'applicationTransfer',
                  value: function(e, t, s) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'applicationTransfer(): ' + e + ', ' + t),
                        this.socket.sendCommand(c.deviceIds.APPLICATION_MANAGER, 'applicationTransfer', e, t, s);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'applicationTransfer() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'sendApplicationStatusReasonIndicator',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'sendApplicationStatusReasonIndicator(): ' + e),
                        this.socket.sendCommand(
                          c.deviceIds.APPLICATION_MANAGER,
                          'sendApplicationStatusReasonIndicator',
                          e
                        );
                    } catch (e) {
                      this.logMessage(
                        c.TraceLevels.LOG_TRACE,
                        'sendApplicationStatusReasonIndicator() exception: ' + e
                      );
                    }
                  },
                },
                {
                  key: 'sendApplicationStatusTransactionIndicator',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'sendApplicationStatusTransactionIndicator(): ' + e),
                        this.socket.sendCommand(
                          c.deviceIds.APPLICATION_MANAGER,
                          'sendApplicationStatusTransactionIndicator',
                          e
                        );
                    } catch (e) {
                      this.logMessage(
                        c.TraceLevels.LOG_TRACE,
                        'sendApplicationStatusTransactionIndicator() exception: ' + e
                      );
                    }
                  },
                },
                {
                  key: 'getVendor',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getVendor(): '),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getVendor');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getVendor() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getConfig',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'getConfig(): ' + e),
                        this.socket.sendRequest(c.deviceIds.APPLICATION_MANAGER, 'getConfig', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getConfig() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setKioskTypeId',
                  value: function(e) {
                    this.kioskTypeId = e;
                  },
                },
                {
                  key: 'OnChange',
                  set: function(e) {
                    this.onChange = e;
                  },
                },
                {
                  key: 'OnActive',
                  set: function(e) {
                    this.onActive = e;
                  },
                },
                {
                  key: 'OnSocketOpened',
                  set: function(e) {
                    this.onSocketOpened = e;
                  },
                },
                {
                  key: 'Active',
                  set: function(e) {
                    (this.isActive = e),
                      this.onActive &&
                        'function' == typeof this.onActive &&
                        this.onActive({
                          key: 'isActive',
                          value: e,
                        });
                  },
                },
                {
                  key: 'KioskId',
                  set: function(e) {
                    this.kioskId !== e &&
                      ((this.kioskId = e),
                      this.onChange &&
                        'function' == typeof this.onChange &&
                        this.onChange({
                          key: 'kioskId',
                          value: e,
                        }));
                  },
                },
                {
                  key: 'AirportCode',
                  set: function(e) {
                    this.airportCode !== e &&
                      ((this.airportCode = e),
                      this.onChange &&
                        'function' == typeof this.onChange &&
                        this.onChange({ key: 'airportCode', value: e }));
                  },
                },
                {
                  key: 'Location',
                  set: function(e) {
                    this.location !== e &&
                      ((this.location = e),
                      this.onChange &&
                        'function' == typeof this.onChange &&
                        this.onChange({ key: 'location', value: e }));
                  },
                },
                {
                  key: 'CompanyCode',
                  set: function(e) {
                    this.companyCode !== e &&
                      ((this.companyCode = e),
                      this.onChange &&
                        'function' == typeof this.onChange &&
                        this.onChange({ key: 'companyCode', value: e }));
                  },
                },
                {
                  key: 'AppName',
                  set: function(e) {
                    this.appName !== e &&
                      ((this.appName = e),
                      this.onChange &&
                        'function' == typeof this.onChange &&
                        this.onChange({
                          key: 'appName',
                          value: e,
                        }));
                  },
                },
              ]),
              t
            );
          })(h.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(6),
          d = s(2),
          h = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'notificationText',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'notificationText() called ' + e),
                      e.indexOf('ACCESSIBLE=TRUE') >= 0 &&
                        this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'Start in accessible mode.'),
                      this.setEvent('notificationText', e);
                  },
                },
                {
                  key: 'getCurrentState',
                  value: function(e) {
                    var t = parseInt(e, 10);
                    this.logMessage(
                      d.TraceLevels.LOG_EXT_TRACE,
                      'getCurrentState() result ' + e + ' ' + (0, u.getKeyByValue)(d.ApplicationState, t)
                    ),
                      this.setEvent('getCurrentState', t),
                      (this.device.currentState = t),
                      this.device.prom &&
                        (clearTimeout(this.device.pTimer),
                        this.device.prom[d.PromiseCodes.RESOLVE](e),
                        (this.device.prom = null));
                  },
                },
                {
                  key: 'sysmgrCommand',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'sysmgrCommand() called ' + e),
                      this.setEvent('sysmgrCommand', e);
                  },
                },
                {
                  key: 'notifyActive',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'notifyActive() called ' + e),
                      this.device.dm.TSDMan &&
                        this.device.dm.TSDMan.addAppStateEvent(d.AppStateEventType.APP_ACTIVATED),
                      (this.device.Active = !0);
                  },
                },
                {
                  key: 'notifyAvailable',
                  value: function() {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'notifyAvailable() called'),
                      (this.device.Active = !1),
                      this.setEvent('notifyAvailable', null);
                  },
                },
                {
                  key: 'notifyUnavailable',
                  value: function() {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'notifyUnavailable() called'),
                      (this.device.Active = !1),
                      this.setEvent('notifyUnavailable', null);
                  },
                },
                {
                  key: 'restart',
                  value: function() {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'restart() called'),
                      (this.device.Active = !1),
                      this.setEvent('restart', null);
                  },
                },
                {
                  key: 'outOfTime',
                  value: function() {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'outOfTime() called'),
                      this.setEvent('outOfTime', null);
                  },
                },
                {
                  key: 'almostOutOfTime',
                  value: function() {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'almostOutOfTime() called'),
                      this.device.dm.TSDMan &&
                        this.device.dm.TSDMan.addAppStateEvent(d.AppStateEventType.PLT_SESSION_TIMEOUT),
                      this.setEvent('almostOutOfTime', null);
                  },
                },
                {
                  key: 'getKioskId',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getKioskID() result: ' + e),
                      (this.device.KioskId = null == e ? '' : e);
                  },
                },
                {
                  key: 'getActualCUSSKioskId',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getActualCUSSKioskId() result: ' + e),
                      (this.device.cussKioskId = null == e ? '' : e);
                  },
                },
                {
                  key: 'getSystemManagerKioskId',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getSystemManagerKioskId() result: ' + e),
                      (this.device.smKioskId = null == e ? '' : e);
                  },
                },
                {
                  key: 'getLocation',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getLocation() result: ' + e),
                      (this.device.Location = null == e ? '' : e);
                  },
                },
                {
                  key: 'getAirportCode',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getAirportCode() result: ' + e),
                      (this.device.AirportCode = null == e ? '' : e);
                  },
                },
                {
                  key: 'socketOpened',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'socketOpened() called: restarting: ' + e),
                      e ||
                        (this.device.getKioskId(),
                        this.device.getSystemManagerKioskId(),
                        this.device.getActualCUSSKioskId(),
                        this.device.getAirportCode(),
                        this.device.getCurrentState(),
                        this.device.getLocation(),
                        this.device.getCompanyCode(),
                        this.device.getAppName(),
                        '' !== this.device.kioskTypeId && this.device.getConfig(this.device.kioskTypeId),
                        this.device.onSocketOpened && this.device.onSocketOpened(e));
                  },
                },
                {
                  key: 'accessibleModeStart',
                  value: function() {
                    this.logMessage(
                      d.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.accessibleModeStart() called'
                    ),
                      this.device.confirmAccessibleMode(),
                      this.setEvent('accessibleMode', !0);
                  },
                },
                {
                  key: 'accessibleModeEnd',
                  value: function() {
                    this.logMessage(
                      d.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.accessibleModeEnd() called'
                    ),
                      this.device.completeAccessibleMode(),
                      this.setEvent('accessibleMode', !1);
                  },
                },
                {
                  key: 'getCompanyCode',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getCompanyCode() result: ' + e),
                      (this.device.CompanyCode = null == e ? '' : e);
                  },
                },
                {
                  key: 'getAppName',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getAppName() result: ' + e),
                      (this.device.AppName = null == e ? '' : e);
                  },
                },
                {
                  key: 'getConfig',
                  value: function(e) {
                    this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getConfig() result: ' + e);
                    var t = e.split(',');
                    2 === t.length
                      ? t[0] === this.device.kioskTypeId && (this.device.kioskType = null == t[1] ? '' : t[1])
                      : this.logMessage(d.TraceLevels.LOG_EXT_TRACE, 'getConfig() incorrect Response! ' + e),
                      this.setEvent('getConfig', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = h), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var n = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          a = s(2),
          r = (function() {
            function e() {
              i(this, e), (this.device = null);
            }

            return (
              n(e, [
                {
                  key: 'logMessage',
                  value: function(e, t) {
                    null != this.device ? this.device.logMessage(e, t) : console.log('Log: ' + t);
                  },
                },
                {
                  key: 'setEvent',
                  value: function(e, t) {
                    this.device.DeviceEvent = { key: e, value: t };
                  },
                },
                {
                  key: 'commandTimeout',
                  value: function(e) {
                    this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.commandTimeoutMethod() called for: ' + e),
                      this.setEvent('commandTimeout', e);
                  },
                },
                {
                  key: 'statusResponse',
                  value: function(e) {
                    this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.statusResponse() called for: ' + e),
                      this.setEvent('statusResponse', e);
                  },
                },
                {
                  key: 'isOK',
                  value: function(e) {
                    this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.isOK() ' + this.device.name + ' -> ' + e),
                      (this.device.isDeviceOk = '1' === e),
                      this.setEvent('isOK', this.device.isDeviceOk);
                  },
                },
                {
                  key: 'statusChange',
                  value: function(e) {
                    this.logMessage(
                      a.TraceLevels.LOG_EXT_TRACE,
                      'Listener.statusChange() ' + this.device.name + ' -> ' + e
                    );
                    var t = e.split(',').map(function(e) {
                      return e.trim();
                    });
                    2 === t.length
                      ? ((this.device.deviceStatus = parseInt(t[0], 10)),
                        this.device.isDeviceRequired &&
                          !this.device.isDeviceOk &&
                          'false' === t[1] &&
                          (this.logMessage(
                            a.TraceLevels.LOG_EXT_TRACE,
                            'Listener.statusChange() device become OK: ' + this.device.name
                          ),
                          this.device.dm.onReqDeviceOK && this.device.dm.onReqDeviceOK(this.device.deviceId)),
                        (this.device.isDeviceOk = 'false' === t[1]),
                        (e = [this.device.deviceStatus, !this.device.isDeviceOk]),
                        this.setEvent('statusChange', e))
                      : this.logMessage(
                          a.TraceLevels.LOG_EXT_TRACE,
                          'Listener.statusChange() incorrect Response! ' + e
                        );
                  },
                },
                {
                  key: 'statusIsOK',
                  value: function(e) {
                    this.logMessage(
                      a.TraceLevels.LOG_EXT_TRACE,
                      'Listener.statusIsOK() ' + this.device.name + ' -> ' + e
                    ),
                      this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.statusIsOK() result ' + e),
                      (this.device.statusOK = e);
                    var t = e.split(','),
                      s = !1;
                    if (2 === t.length) {
                      this.device.deviceStatus = parseInt(t[0], 10);
                      var i = '1' === t[1];
                      i !== this.device.isDeviceOk && (s = !0), (this.device.isDeviceOk = i);
                    } else {
                      this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.statusIsOK() incorrect Response! ' + e);
                    }
                    this.device.prom
                      ? (clearTimeout(this.device.pTimer),
                        this.device.prom[a.PromiseCodes.RESOLVE](e),
                        (this.device.prom = null),
                        s && this.setEvent('statusIsOK', e))
                      : this.setEvent('statusIsOK', e);
                  },
                },
                {
                  key: 'getKioskDeviceHelp',
                  value: function(e) {
                    this.logMessage(a.TraceLevels.LOG_EXT_TRACE, 'Listener.getKioskDeviceHelp() ' + this.device.name),
                      this.setEvent('getKioskDeviceHelp', e);
                  },
                },
              ]),
              e
            );
          })();
        (t.default = r), (e.exports = t.default);
      },
      function(e, t) {
        'use strict';

        function s(e) {
          var t = e;
          return 0 === e.indexOf('[') && (t = e.substring(1, e.length - 1)), t;
        }

        function i(e, t) {
          var s = '';
          for (var i in e) {
            e.hasOwnProperty(i) && e[i] === t && (s = i);
          }
          return s;
        }

        function n() {
          var e = new Date();
          return e.getHours() + ':' + e.getMinutes() + ':' + e.getSeconds() + ':' + e.getMilliseconds();
        }

        function a(e) {
          return e;
        }

        function r(e) {
          return void 0 !== e && null !== e && e % 1 === 0;
        }

        function o(e, t) {
          return e.indexOf(t, e.length - t.length) !== -1;
        }

        Object.defineProperty(t, '__esModule', { value: !0 }),
          (t.removeArrayBrackets = s),
          (t.getKeyByValue = i),
          (t.getTime = n),
          (t.debugObject = a),
          (t.isInteger = r),
          (t.endsWith = o);
      },
      function(e, t, s) {
        'use strict';

        function i(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var n = (function() {
            function e(e, t) {
              var s = [],
                i = !0,
                n = !1,
                a = void 0;
              try {
                for (
                  var r, o = e[Symbol.iterator]();
                  !(i = (r = o.next()).done) && (s.push(r.value), !t || s.length !== t);
                  i = !0
                ) {}
              } catch (e) {
                (n = !0), (a = e);
              } finally {
                try {
                  !i && o.return && o.return();
                } finally {
                  if (n) {
                    throw a;
                  }
                }
              }
              return s;
            }

            return function(t, s) {
              if (Array.isArray(t)) {
                return t;
              }
              if (Symbol.iterator in Object(t)) {
                return e(t, s);
              }
              throw new TypeError('Invalid attempt to destructure non-iterable instance');
            };
          })(),
          a = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          r = s(2),
          o = (function() {
            function e(t, s) {
              i(this, e),
                (this.listener = null),
                (this.defaultListener = null),
                (this.name = 'Generic Device'),
                (this.dm = s),
                (this.socket = t),
                (this.deviceId = null),
                (this.onDeviceEvent = null),
                (this.devEventListeners = new Map()),
                (this.deviceEvent = null),
                (this.deviceStatus = null),
                (this.isDeviceOk = !1),
                (this.isRequired = !1),
                (this.type = null),
                (this.maxTraceLevelToSend = r.TraceLevels.LOG_EXT_TRACE),
                (this.addTimeToTrace = !0),
                (this.statusOK = ''),
                (this.prom = null),
                (this.pTimer = null),
                (this.promiseTimeout = 1e3);
            }

            return (
              a(e, [
                {
                  key: 'addListener',
                  value: function(e, t) {
                    this.devEventListeners.set(e, t);
                  },
                },
                {
                  key: 'removeListener',
                  value: function(e) {
                    this.devEventListeners.delete(e);
                  },
                },
                {
                  key: 'setMaxTraceLevel',
                  value: function(e) {
                    this.maxTraceLevelToSend = e;
                  },
                },
                {
                  key: 'setAddTimeToTrace',
                  value: function(e) {
                    this.addTimeToTrace = e;
                  },
                },
                {
                  key: 'setPromiseTimeout',
                  value: function(e) {
                    this.promiseTimeout = e;
                  },
                },
                {
                  key: 'logMessage',
                  value: function(e, t) {
                    this.dm ? this.dm.dmLog(e, t) : console.log(t);
                  },
                },
                {
                  key: 'setListener',
                  value: function(e) {
                    (this.listener = e), (e.device = this), this.socket.addListener(this.getListener());
                  },
                },
                {
                  key: 'getListener',
                  value: function() {
                    return this.listener;
                  },
                },
                {
                  key: 'getName',
                  value: function() {
                    return this.name;
                  },
                },
                {
                  key: 'isOK',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isOK'),
                        this.logMessage(r.TraceLevels.LOG_TRACE, 'isOK(): ' + this.name);
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'isOK() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'status',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'status'),
                        this.logMessage(r.TraceLevels.LOG_TRACE, 'status(): ' + this.name);
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'status() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'statusIsOK',
                  value: function(e) {
                    var t = this;
                    try {
                      this.logMessage(
                        r.TraceLevels.LOG_TRACE,
                        'statusIsOK(): ' + (void 0 === e ? '' : 'returnPromise: ' + (e + ' ' + this.promiseTimeout))
                      );
                      var s = null;
                      if (
                        (e === !0 &&
                          (s =
                            null == this.prom
                              ? new Promise(function(e, s) {
                                  (t.prom = [e, s]),
                                    (t.pTimer = setTimeout(function() {
                                      t.prom &&
                                        (t.prom[r.PromiseCodes.REJECT](r.PromiseCodes.TIMEOUT), (t.prom = null));
                                    }, t.promiseTimeout));
                                })
                              : new Promise(function(e, t) {
                                  setTimeout(function() {
                                    t(r.PromiseCodes.UNEXPECTED);
                                  }, 10);
                                })),
                        this.socket.sendRequest(this.deviceId, 'statusIsOK'),
                        this.logMessage(r.TraceLevels.LOG_TRACE, 'statusIsOK(): ' + this.name),
                        e === !0)
                      ) {
                        return s;
                      }
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'statusIsOK() exception: ' + e);
                    }
                    return null;
                  },
                },
                {
                  key: 'enable',
                  value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                    try {
                      this.deviceId === r.deviceIds.CARD_READER
                        ? this.logMessage(r.TraceLevels.LOG_TRACE, 'enable(): ' + this.deviceId + ' enableType: ' + e)
                        : this.logMessage(r.TraceLevels.LOG_TRACE, 'enable(): ' + this.deviceId),
                        this.dm.tsdDeviceEvent(r.DeviceEventType.ENABLED, this.deviceId, this.name),
                        e === -1
                          ? this.socket.sendCommand(this.deviceId, 'enable')
                          : this.socket.sendCommand(this.deviceId, 'enable', e);
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'enable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'disable',
                  value: function() {
                    try {
                      this.logMessage(r.TraceLevels.LOG_TRACE, 'disable(): ' + this.deviceId),
                        this.dm.tsdDeviceEvent(r.DeviceEventType.DISABLED, this.deviceId, this.name),
                        this.socket.sendCommand(this.deviceId, 'disable');
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'disable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getKioskDeviceHelp',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getKioskDeviceHelp'),
                        this.logMessage(r.TraceLevels.LOG_TRACE, 'getKioskDeviceHelp(): ');
                    } catch (e) {
                      this.logMessage(r.TraceLevels.LOG_ALERT, 'getKioskDeviceHelp() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getIsDeviceOk',
                  value: function() {
                    return this.isDeviceOk;
                  },
                },
                {
                  key: 'isDeviceRequired',
                  value: function() {
                    return this.isRequired;
                  },
                },
                {
                  key: 'DeviceEvent',
                  set: function(e) {
                    this.deviceEvent = e;
                    try {
                      this.dm.tsdDeviceEvent(e.key, this.deviceId, this.name, e.value);
                    } catch (e) {
                      return void this.logMessage(
                        r.TraceLevels.LOG_ALERT,
                        'set device tsdDeviceEvent : ' + this.deviceId + ' error: ' + e
                      );
                    }
                    try {
                      this.onDeviceEvent && 'function' == typeof this.onDeviceEvent && this.onDeviceEvent(e);
                    } catch (e) {
                      return void this.logMessage(
                        r.TraceLevels.LOG_ALERT,
                        'set device onDeviceEvent: ' + this.deviceId + ' error: ' + e
                      );
                    }
                    try {
                      var t = !0,
                        s = !1,
                        i = void 0;
                      try {
                        for (var a, o = this.devEventListeners[Symbol.iterator](); !(t = (a = o.next()).done); t = !0) {
                          var c = n(a.value, 2),
                            l = c[0],
                            u = c[1];
                          'function' == typeof u &&
                            (this.logMessage(r.TraceLevels.LOG_EXT_TRACE, 'call listener: ' + l + ' ' + e.key), u(e));
                        }
                      } catch (e) {
                        (s = !0), (i = e);
                      } finally {
                        try {
                          !t && o.return && o.return();
                        } finally {
                          if (s) {
                            throw i;
                          }
                        }
                      }
                    } catch (e) {
                      return void this.logMessage(
                        r.TraceLevels.LOG_ALERT,
                        'set device devEventListeners: ' + this.deviceId + ' error: ' + e
                      );
                    }
                  },
                },
                {
                  key: 'OnDeviceEvent',
                  set: function(e) {
                    this.onDeviceEvent = e;
                  },
                },
                {
                  key: 'IsRequired',
                  set: function(e) {
                    this.isRequired = e;
                  },
                },
              ]),
              e
            );
          })();
        (t.default = o), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var n =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function(e) {
                  return typeof e;
                }
              : function(e) {
                  return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                    ? 'symbol'
                    : typeof e;
                },
          a = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          r = s(2),
          o = s(6),
          c = (function() {
            function e(t, s, n, a, r, o) {
              i(this, e),
                (this.url = t),
                (this.port = s),
                (this.websocket = null),
                (this.requestId = 0),
                (this.callbacks = []),
                (this.timer = []),
                (this.isOpened = !1),
                (this.listeners = new Map()),
                this.listeners.set('default', this.defaultEventHandler),
                (this.autoReconnect = !0),
                (this.wsCallback = n),
                (this.keepAliveTimer = null),
                (this.noWebsocket = r),
                (this.getMaxTraceLevel = a),
                (this.restarting = !1),
                (this.dmLog = o),
                (this.defaultTimeout = 6e4);
            }

            return (
              a(e, [
                {
                  key: 'addListener',
                  value: function(e) {
                    this.listeners.set(e.device.deviceId, e);
                  },
                },
                {
                  key: 'removeListener',
                  value: function(e) {
                    this.listeners.delete(e);
                  },
                },
                {
                  key: 'defaultEventHandler',
                  value: function() {
                    this.logMessage(r.TraceLevels.LOG_EXT_TRACE, 'LinkSocket::default eventHandler is called.');
                  },
                },
                {
                  key: 'open',
                  value: function() {
                    this.logMessage(
                      r.TraceLevels.LOG_SYSTEM,
                      'construct DeviceWS ... url = ' + this.url + ':' + this.port
                    ),
                      (this.websocket = new WebSocket('ws://' + this.url + ':' + this.port)),
                      (this.websocket.onmessage = this.socketOnMessage.bind(this)),
                      (this.websocket.onclose = this.socketOnClose.bind(this)),
                      (this.websocket.onopen = this.socketOnOpen.bind(this)),
                      (this.websocket.onerror = this.socketOnError.bind(this));
                  },
                },
                {
                  key: 'socketOnOpen',
                  value: function(e) {
                    this.logMessage(r.TraceLevels.LOG_SYSTEM, 'WebSocket is connected.'),
                      (this.isOpened = !0),
                      this.wsCallback(e);
                  },
                },
                {
                  key: 'socketOnMessage',
                  value: function(e) {
                    this.logMessage(r.TraceLevels.LOG_TRACE, 'socket on message => Event.data:' + e.data, !0);
                    var t = '';
                    try {
                      t = JSON.parse(e.data);
                    } catch (s) {
                      ('string' == typeof e.data && e.data.indexOf('Hello') >= 0) ||
                        this.logMessage(r.TraceLevels.LOG_ALERT, 'parse event fail, err: ' + s),
                        (t = e.data);
                    }
                    if ('string' == typeof t && t.indexOf('Hello') >= 0) {
                      this.logMessage(r.TraceLevels.LOG_SYSTEM, 'Message from server:[' + t + ']'),
                        (this.isOpened = !0),
                        this.listeners.get(r.deviceIds.APPLICATION_MANAGER).socketOpened(this.restarting),
                        (this.restarting = !1);
                    } else if (
                      'object' === ('undefined' == typeof t ? 'undefined' : n(t)) &&
                      'corrId' in t &&
                      this.callbacks[t.corrId]
                    ) {
                      var s = this.callbacks[t.corrId];
                      delete this.callbacks[t.corrId],
                        clearTimeout(this.timer[t.corrId]),
                        delete this.timer[t.corrId],
                        this.logMessage(
                          r.TraceLevels.LOG_SYSTEM,
                          'Response corrId:' + t.corrId + ' comp: ' + t.comp + ' methodId: ' + t.methodId
                        ),
                        s[0](t.response);
                      var i = null;
                      if (t.comp !== r.deviceIds.APPLICATION_MANAGER) {
                        switch (t.methodId) {
                          case r.methods.status:
                            i = 'statusResponse';
                            break;
                          default:
                            i = (0, o.getKeyByValue)(r.methods, t.methodId);
                        }
                      } else {
                        i = (0, o.getKeyByValue)(r.methods, t.methodId);
                      }
                      this.listeners.get(t.comp)[i](t.response);
                    } else if ('object' === ('undefined' == typeof t ? 'undefined' : n(t)) && 'event' in t) {
                      try {
                        this.listeners.get(t.comp)[t.event]((0, o.removeArrayBrackets)(t.params));
                      } catch (e) {
                        this.logMessage(r.TraceLevels.LOG_ALERT, 'error in listener for: ' + t.event + ' err: ' + e);
                      }
                    } else {
                      this.logMessage(r.TraceLevels.LOG_EXT_TRACE, 'command response no need to handle (no corrId).');
                    }
                  },
                },
                {
                  key: 'socketOnError',
                  value: function(e) {
                    this.logMessage(r.TraceLevels.ALERT, 'ws error: ' + e), (this.isOpened = !1), this.wsCallback(e);
                  },
                },
                {
                  key: 'socketOnClose',
                  value: function(e) {
                    var t = this;
                    (this.isOpened = !1),
                      this.logMessage(
                        r.TraceLevels.LOG_SYSTEM,
                        'socketOnClose: ' + e.code + ' ' + e.reason + ' ' + e.wasClean
                      ),
                      this.autoReconnect &&
                        (this.logMessage(r.TraceLevels.LOG_SYSTEM, 'auto reconnect ...'),
                        setTimeout(function() {
                          t.logMessage(r.TraceLevels.LOG_SYSTEM, 'reconnect - open'), (t.restarting = !0), t.open();
                        }, 500)),
                      this.wsCallback(e);
                  },
                },
                {
                  key: 'close',
                  value: function() {
                    (this.isOpened = !1), (this.autoReconnect = !1), this.websocket.close();
                  },
                },
                {
                  key: 'getRequestId',
                  value: function() {
                    return ++this.requestId;
                  },
                },
                {
                  key: 'callRemoteMethod',
                  value: function(e, t, s) {
                    for (var i = arguments.length, n = Array(i > 3 ? i - 3 : 0), a = 3; a < i; a++) {
                      n[a - 3] = arguments[a];
                    }
                    var o = this;
                    if (arguments.length < 2) {
                      return '';
                    }
                    this.isOpened || this.logMessage(r.TraceLevels.LOG_SYSTEM, 'websocket is not opened'),
                      2 === arguments.length && (s = !0);
                    var c = -1,
                      l = null;
                    s ||
                      ((c = this.getRequestId()),
                      this.logMessage(
                        r.TraceLevels.LOG_TRACE,
                        'new corrid generated: ' + c + ' for method:' + t + ' comp:' + e
                      ),
                      (l = new Promise(function(s, i) {
                        (o.callbacks[c] = [s, i]),
                          (o.timer[c] = setTimeout(
                            function(e, t, s) {
                              o.logMessage(
                                r.TraceLevels.LOG_TRACE,
                                'Timeout function this.callbacks[corrid]: [' + e + '] ' + t + ' ' + s
                              ),
                                o.callbacks[e] &&
                                  (o.logMessage(r.TraceLevels.LOG_TRACE, 'Timeout after ' + o.defaultTimeout + ' ms'),
                                  o.callbacks[e][0]('timeout'),
                                  o.listeners.get(t).commandTimeout(s),
                                  delete o.callbacks[e],
                                  delete o.timer[e]);
                            },
                            o.defaultTimeout,
                            c,
                            e,
                            t
                          ));
                      })));
                    var u = this.buildJSONString.apply(this, [e, t, c].concat(n));
                    return this.isOpened && this.websocket.send(u), s ? c : l;
                  },
                },
                {
                  key: 'sendCommand',
                  value: function(e, t) {
                    if (this.noWebsocket === !0) {
                      return !0;
                    }
                    for (var s = arguments.length, i = Array(s > 2 ? s - 2 : 0), n = 2; n < s; n++) {
                      i[n - 2] = arguments[n];
                    }
                    return this.callRemoteMethod.apply(this, [e, t, !0].concat(i));
                  },
                },
                {
                  key: 'sendRequest',
                  value: function(e, t) {
                    if (this.noWebsocket === !0) {
                      return !0;
                    }
                    for (var s = arguments.length, i = Array(s > 2 ? s - 2 : 0), n = 2; n < s; n++) {
                      i[n - 2] = arguments[n];
                    }
                    return this.callRemoteMethod.apply(this, [e, t, !1].concat(i));
                  },
                },
                {
                  key: 'buildJSONString',
                  value: function(e, t, s) {
                    for (var i = arguments.length, n = Array(i > 3 ? i - 3 : 0), a = 3; a < i; a++) {
                      n[a - 3] = arguments[a];
                    }
                    var r = {
                      comp: e,
                      method: t,
                      corrId: s,
                      params: [].concat(n),
                    };
                    return JSON.stringify(r);
                  },
                },
                {
                  key: 'logMessage',
                  value: function(e, t, s) {
                    if (s) {
                      var i = t.substring(0, 72);
                      i.indexOf('ticketPrinted') > -1 ||
                      i.indexOf('ticketFailed') > -1 ||
                      i.indexOf('bagtagPrinted') > -1 ||
                      i.indexOf('bagtagFailed') > -1
                        ? this.dmLog(e, 'LS: ' + t.substring(0, 85) + '... msg lth: ' + t.length)
                        : i.indexOf('Read') > -1 || i.indexOf('pictureTaken') > -1
                        ? this.dmLog(e, 'LS: ' + i + '... msg lth: ' + t.length)
                        : this.dmLog(e, 'LS: ' + t);
                    } else {
                      this.dmLog(e, 'LS: ' + t);
                    }
                  },
                },
                {
                  key: 'setDefaultTimeout',
                  value: function(e) {
                    this.defaultTimeout = e;
                  },
                },
              ]),
              e
            );
          })();
        (t.default = c), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(10),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Barcode Reader'),
                (i.deviceId = c.deviceIds.BARCODE_READER),
                i.setListener(new h.default()),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'read',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'read().'),
                        this.socket.sendRequest(this.deviceId, 'read');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'read() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'eject',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'eject().'),
                        this.socket.sendRequest(this.deviceId, 'eject');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'eject() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = s(6),
          h = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'barcodeReadInternal',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'BarcodeReaderListener.barcodeReadInternal() called: '
                    );
                    try {
                      var t = e && e.length > 0 && (0, d.endsWith)(e, '\r') ? e.substring(0, e.length - 1) : e;
                      this.setEvent('barcodeReadInternal', t);
                    } catch (e) {
                      this.logMessage(
                        u.TraceLevels.LOG_EXT_TRACE,
                        'BarcodeReaderListener.barcodeReadInternal() err: ' + e
                      );
                    }
                  },
                },
                {
                  key: 'barcodeDamaged',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BarcodeReaderListener.barcodeDamagedMethod() called'),
                      this.setEvent('barcodeDamaged', null);
                  },
                },
                {
                  key: 'barcodeInserted',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'BarcodeReaderListener.barcodeInsertedMethod() called'
                    ),
                      this.setEvent('barcodeInserted', null);
                  },
                },
                {
                  key: 'barcodeRead',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BarcodeReaderListener.barcodeReadMethod() called'),
                      this.setEvent('barcodeRead', e);
                  },
                },
                {
                  key: 'barcodeRemoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BarcodeReaderListener.barcodeRemovedMethod() called'),
                      this.setEvent('barcodeRemoved', null);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = h), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = s(2),
          c = s(7),
          l = i(c),
          u = s(12),
          d = i(u),
          h = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Card Reader'), (i.deviceId = o.deviceIds.CARD_READER), i.setListener(new d.default()), i
              );
            }

            return r(t, e), t;
          })(l.default);
        (t.default = h), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'cardReadInternal',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardReadInternal called'),
                      this.setEvent('cardReadInternal', e);
                  },
                },
                {
                  key: 'cardEjected',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardEjected() called'),
                      this.setEvent('cardEjected', null);
                  },
                },
                {
                  key: 'cardInsertedIncomplete',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardInsertedIncomplete() called'),
                      this.setEvent('cardInsertedIncomplete', null);
                  },
                },
                {
                  key: 'cardInThroat',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardInThroat() called'),
                      this.setEvent('cardInThroat', null);
                  },
                },
                {
                  key: 'cardInserted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardInserted() called'),
                      this.setEvent('cardInserted', null);
                  },
                },
                {
                  key: 'cardRemoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardRemoved() called'),
                      this.setEvent('cardRemoved', null);
                  },
                },
                {
                  key: 'cardDamaged',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardDamaged() called'),
                      this.setEvent('cardDamaged', null);
                  },
                },
                {
                  key: 'cardRead',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CardReaderListener.cardRead() called'),
                      this.setEvent('cardRead', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(14),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Passport Reader'),
                (i.deviceId = c.deviceIds.PASSPORT_READER),
                i.setListener(new h.default()),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'isDIP',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isDIP().'),
                        this.socket.sendRequest(this.deviceId, 'isDIP');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isDIP() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isSwipe',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isSwipe().'),
                        this.socket.sendRequest(this.deviceId, 'isSwipe');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isSwipe() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isMotorized',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isMotorized().'),
                        this.socket.sendRequest(this.deviceId, 'isMotorized');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isMotorized() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isPassportInReader',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isPassportInReader().'),
                        this.socket.sendRequest(this.deviceId, 'isPassportInReader');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isPassportInReader() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isPassportPartiallyInserted',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'isPassportPartiallyInserted().'),
                        this.socket.sendRequest(this.deviceId, 'isPassportPartiallyInserted');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isPassportPartiallyInserted() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'read',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'read().'),
                        this.socket.sendRequest(this.deviceId, 'read');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'read() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setup',
                  value: function(e, t) {
                    try {
                      void 0 === t
                        ? (this.logMessage(c.TraceLevels.LOG_TRACE, 'setup(): called with: ' + e),
                          this.socket.sendRequest(this.deviceId, 'setup', e))
                        : (this.logMessage(c.TraceLevels.LOG_TRACE, 'setup(): called with: ' + e + ' pax: ' + t),
                          this.socket.sendRequest(this.deviceId, 'setup', e, t));
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setup() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setPaxId',
                  value: function(e) {
                    try {
                      void 0 !== e &&
                        (this.logMessage(c.TraceLevels.LOG_TRACE, 'setPaxId(): called with: ' + e),
                        this.socket.sendCommand(this.deviceId, 'setPaxId', e));
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setPaxId() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'parse',
                  value: function(e) {
                    try {
                      void 0 !== e &&
                        (this.logMessage(
                          c.TraceLevels.LOG_TRACE,
                          'parse(): called with: ' + (e ? e.substring(0, 4) : '')
                        ),
                        this.socket.sendRequest(this.deviceId, 'parse', e));
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'parse() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'passportReadInternal',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'PassportReaderListener.passportReadInternalMethod() called'
                    ),
                      this.setEvent('passportReadInternal', e);
                  },
                },
                {
                  key: 'passportDamaged',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'PassportReaderListener.passportDamagedMethod() called'
                    ),
                      this.setEvent('passportDamaged', null);
                  },
                },
                {
                  key: 'passportInserted',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'PassportReaderListener.passportInsertedMethod() called'
                    ),
                      this.setEvent('passportInserted', null);
                  },
                },
                {
                  key: 'passportRead',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'PassportReaderListener.passportReadMethod() called'),
                      this.setEvent('passportRead', e);
                  },
                },
                {
                  key: 'passportRemoved',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'PassportReaderListener.passportRemovedMethod() called'
                    ),
                      this.setEvent('passportRemoved', null);
                  },
                },
                {
                  key: 'accessingRFChip',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'PassportReaderListener.accessingRFChip() called'),
                      this.setEvent('accessingRFChip', null);
                  },
                },
                {
                  key: 'passportDataError',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'PassportReaderListener.passportDataError() called'),
                      this.setEvent('passportDataError', e);
                  },
                },
                {
                  key: 'setup',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'PassportReaderListener.setup() called: ' + e),
                      this.setEvent('setup', e);
                  },
                },
                {
                  key: 'parse',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'PassportReaderListener.parse() called.');
                    var t = e.split(',').map(function(e) {
                      return e.trim();
                    });
                    t.length > 1
                      ? this.setEvent('parse', t)
                      : (this.logMessage(
                          u.TraceLevels.LOG_EXT_TRACE,
                          'PassportReaderListener.parse() incorrect Response! ' + e
                        ),
                        this.setEvent('parse', []));
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(7),
          l = i(c),
          u = s(2),
          d = s(16),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'ATB Printer'), (i.deviceId = u.deviceIds.ATB_PRINTER), i.setListener(new h.default()), i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'areAllBinsEmpty',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'areAllBinsEmpty().'),
                        this.socket.sendRequest(this.deviceId, 'areAllBinsEmpty');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'areAllBinsEmpty() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isTicketInHopper',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isTicketInHopper().'),
                        this.socket.sendRequest(this.deviceId, 'isTicketInHopper');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isTicketInHopper() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isTicketInPrinter',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'isTicketInPrinter().'),
                        this.socket.sendRequest(this.deviceId, 'isTicketInPrinter');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isTicketInPrinter() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isPectabLoadedInPrinter',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isPectabLoadedInPrinter().'),
                        this.socket.sendRequest(this.deviceId, 'isPectabLoadedInPrinter');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isPectabLoadedInPrinter() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getBinStatus',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'getBinStatus().'),
                        this.socket.sendRequest(this.deviceId, 'getBinStatus');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'getBinStatus() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTAB',
                  value: function(e) {
                    try {
                      var t;
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTAB().');
                      for (var s = arguments.length, i = Array(s > 1 ? s - 1 : 0), n = 1; n < s; n++) {
                        i[n - 1] = arguments[n];
                      }
                      (t = this.socket).sendCommand.apply(t, [this.deviceId, 'loadPECTAB', e].concat(i));
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTAB() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTABBase64',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTABBase64().'),
                        this.socket.sendCommand(this.deviceId, 'loadPECTAB', e, !0);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTABBase64() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTABArray',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTABArray() lth: ' + e.length),
                        this.socket.sendCommand(this.deviceId, 'loadPECTABArray', e, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTABArray() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'eject',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'eject().'),
                        this.socket.sendCommand(this.deviceId, 'eject');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'eject() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'capture',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'capture().'),
                        this.socket.sendCommand(this.deviceId, 'capture');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'capture() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'read',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'read().'),
                        this.socket.sendCommand(this.deviceId, 'read');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'read() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'offer',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'offer(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'offer', e);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'offer() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'print',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'print() lth: ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'print', e, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'print() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printBase64',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printBase64(): ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'print', e, !0, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printBase64() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printArray',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printArray() lth: ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'printArray', e, !1, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printArray() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printBase64Array',
                  value: function(e, t) {
                    try {
                      this.logMessage(
                        u.TraceLevels.LOG_TRACE,
                        'printBase64Array() lth: ' + (e ? e.length : '0') + ', ' + t
                      ),
                        this.socket.sendCommand(this.deviceId, 'printArray', e, !0, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printBase64Array() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'ticketEjected',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketEjected() called'),
                      this.setEvent('ticketEjected', null);
                  },
                },
                {
                  key: 'ticketInserted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketInserted() called'),
                      this.setEvent('ticketInserted', null);
                  },
                },
                {
                  key: 'ticketPresent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketPresent() called'),
                      this.setEvent('ticketPresent', null);
                  },
                },
                {
                  key: 'ticketRemoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketRemoved() called'),
                      this.setEvent('ticketRemoved', null);
                  },
                },
                {
                  key: 'ticketRead',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketRead() called'),
                      this.setEvent('ticketRead', null);
                  },
                },
                {
                  key: 'ticketPrinted',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketPrinted() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('ticketPrinted', t);
                  },
                },
                {
                  key: 'ticketFailed',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketFailed() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('ticketFailed', t);
                  },
                },
                {
                  key: 'ticketPrintingComplete',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.ticketPrintingComplete() called'),
                      this.setEvent('ticketPrintingComplete', null);
                  },
                },
                {
                  key: 'pectabLoaded',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.pectabLoaded() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('pectabLoaded', t);
                  },
                },
                {
                  key: 'pectabFailed',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.pectabFailed() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('pectabFailed', t);
                  },
                },
                {
                  key: 'pectabLoadingComplete',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.pectabLoadingComplete() called'),
                      this.setEvent('pectabLoadingComplete', null);
                  },
                },
                {
                  key: 'offer',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'ATBPrinterListener.offer() called'),
                      this.setEvent('offer', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(7),
          l = i(c),
          u = s(2),
          d = s(18),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Bagtag Printer'),
                (i.deviceId = u.deviceIds.BAGTAG_PRINTER),
                i.setListener(new h.default()),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'areAllBinsEmpty',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'areAllBinsEmpty().'),
                        this.socket.sendRequest(this.deviceId, 'areAllBinsEmpty');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'areAllBinsEmpty() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isPectabLoadedInPrinter',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isPectabLoadedInPrinter().'),
                        this.socket.sendRequest(this.deviceId, 'isPectabLoadedInPrinter');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'isPectabLoadedInPrinter() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getBinStatus',
                  value: function() {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'getBinStatus().'),
                        this.socket.sendRequest(this.deviceId, 'getBinStatus');
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'getBinStatus() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTAB',
                  value: function(e) {
                    try {
                      var t;
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTAB().');
                      for (var s = arguments.length, i = Array(s > 1 ? s - 1 : 0), n = 1; n < s; n++) {
                        i[n - 1] = arguments[n];
                      }
                      (t = this.socket).sendCommand.apply(t, [this.deviceId, 'loadPECTAB', e].concat(i));
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTAB() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTABBase64',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTABBase64().'),
                        this.socket.sendCommand(this.deviceId, 'loadPECTAB', e, !0);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTABBase64() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'loadPECTABArray',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'loadPECTABArray() lth: ' + e.length),
                        this.socket.sendCommand(this.deviceId, 'loadPECTABArray', e, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'loadPECTABArray() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'offer',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'offer(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'offer', e);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'offer() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'print',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'print() lth: ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'print', e, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'print() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printBase64',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printBase64() lth: ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'print', e, !0, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printBase64() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printArray',
                  value: function(e, t) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printArray() lth: ' + (e ? e.length : '0') + ', ' + t),
                        this.socket.sendCommand(this.deviceId, 'printArray', e, !1, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printArray() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printBase64Array',
                  value: function(e, t) {
                    try {
                      this.logMessage(
                        u.TraceLevels.LOG_TRACE,
                        'printBase64Array() lth: ' + (e ? e.length : '0') + ', ' + t
                      ),
                        this.socket.sendCommand(this.deviceId, 'printArray', e, !0, t);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printBase64Array() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'bagtagPresent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterListener.bagtagPresentMethod() called'),
                      this.setEvent('bagtagPresent', null);
                  },
                },
                {
                  key: 'bagtagRemoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterListener.bagtagRemovedMethod() called'),
                      this.setEvent('bagtagRemoved', null);
                  },
                },
                {
                  key: 'bagtagPrinted',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterPrinterListener.bagtagPrinted() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('bagtagPrinted', t);
                  },
                },
                {
                  key: 'bagtagFailed',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'BagtagPrinterPrinterListener.bagtagFailedMethod() called'
                    );
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('bagtagFailed', t);
                  },
                },
                {
                  key: 'bagtagPrintingComplete',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'BagtagPrinterPrinterListener.bagtagPrintingCompleteMethod() called'
                    ),
                      this.setEvent('bagtagPrintingComplete', null);
                  },
                },
                {
                  key: 'pectabLoaded',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterPrinterListener.pectabLoaded() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('pectabLoaded', t);
                  },
                },
                {
                  key: 'pectabFailed',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterPrinterListener.pectabFailed() called');
                    var t = e
                      ? e.split(',').map(function(e) {
                          return e.trim();
                        })
                      : [];
                    this.setEvent('pectabFailed', t);
                  },
                },
                {
                  key: 'pectabLoadingComplete',
                  value: function() {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'BagtagPrinterPrinterListener.pectabLoadingComplete() called'
                    ),
                      this.setEvent('pectabLoadingComplete', null);
                  },
                },
                {
                  key: 'offer',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'BagtagPrinterPrinterListener.offer() called'),
                      this.setEvent('offer', e),
                      '104' === e &&
                        (this.logMessage(
                          u.TraceLevels.LOG_EXT_TRACE,
                          'BagtagPrinterListener.offer() - generate bagtagRemoved event'
                        ),
                        this.setEvent('bagtagRemoved', null));
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(20),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Accessibility'),
                (i.deviceId = c.deviceIds.CUSS_ACCESSIBILITY),
                (i.headsetStatus = null),
                (i.headsetAvailable = null),
                (i.keypadStatus = null),
                (i.ttsStatus = null),
                (i.enabled = !1),
                i.setListener(new h.default()),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'isAccessibilitySupported',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isAccessibilitySupported'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'isAccessibilitySupported()');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isAccessibilitySupported() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isHeadsetAvailable',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isHeadsetAvailable'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'isHeadsetAvailable(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isHeadsetAvailable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isHeadsetInserted',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isHeadsetInserted'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'isHeadsetInserted(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isHeadsetInserted() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getStatusHeadset',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getStatusHeadset'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getStatusHeadset(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getStatusHeadset() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enableHeadset',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'enableHeadset()'),
                        this.socket.sendCommand(this.deviceId, 'enableHeadset');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enableHeadset() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'disableHeadset',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'disableHeadset()'),
                        this.socket.sendCommand(this.deviceId, 'disableHeadset');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'disableHeadset() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getStatusTTS',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getStatusTTS'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getStatusTTS(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getStatusTTS() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enableTTS',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'enableTTS()'),
                        this.socket.sendCommand(this.deviceId, 'enableTTS');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enableTTS() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'disableTTS',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'disableTTS()'),
                        this.socket.sendCommand(this.deviceId, 'disableTTS');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'disableTTS() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isTTSAvailable',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isTTSAvailable'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'isTTSAvailable(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isTTSAvailable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'speak',
                  value: function(e, t) {
                    try {
                      this.socket.sendRequest(this.deviceId, 'speak', e, t),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'speak(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'speak() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'play',
                  value: function(e) {
                    try {
                      this.socket.sendRequest(this.deviceId, 'play', e),
                        this.logMessage(
                          c.TraceLevels.LOG_TRACE,
                          'play(), data:' + (e ? e.substring(0, 40) + '...' : '')
                        );
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'play() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'pause',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'pause()'),
                        this.socket.sendCommand(this.deviceId, 'pause');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'pause() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'resume',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'resume()'),
                        this.socket.sendCommand(this.deviceId, 'resume');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'resume() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'stop',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'stop()'),
                        this.socket.sendCommand(this.deviceId, 'stop');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'stop() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getStatusKeypad',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getStatusKeypad'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getStatusKeypad(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getStatusKeypad() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enableKeypad',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'enableKeypad()'),
                        this.socket.sendCommand(this.deviceId, 'enableKeypad');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enableKeypad() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'disableKeypad',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'disableKeypad()'),
                        this.socket.sendCommand(this.deviceId, 'disableKeypad');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'disableKeypad() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getKeypadEvents',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getKeypadEvents'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getKeypadEvents(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getKeypadEvents() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getKeypadType',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getKeypadType'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getKeypadType(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getKeypadType() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'isKeypadAvailable',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'isKeypadAvailable'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'isKeypadAvailable(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'isKeypadAvailable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'status',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getStatusHeadset'),
                        this.socket.sendRequest(this.deviceId, 'getStatusKeypad'),
                        this.socket.sendRequest(this.deviceId, 'getStatusTTS'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'status(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'status() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getHeadsetDeviceHelp',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getHeadsetDeviceHelp'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getHeadsetDeviceHelp(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getHeadsetDeviceHelp() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getKeypadDeviceHelp',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getKeypadDeviceHelp'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getKeypadDeviceHelp(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getKeypadDeviceHelp() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getAvailableLanguages',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getAvailableLanguages'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getAvailableLanguages(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getAvailableLanguages() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getDeviceHelpLanguages',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getDeviceHelpLanguages'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getDeviceHelpLanguages(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getDeviceHelpLanguages() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getDefaultLanguage',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getDefaultLanguage'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getDefaultLanguage(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getDefaultLanguage() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setDefaultLanguage',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'setDefaultLanguage()'),
                        this.socket.sendCommand(this.deviceId, 'setDefaultLanguage', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setDefaultLanguage() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'blankDisplay',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'blankDisplay()'),
                        this.socket.sendCommand(this.deviceId, 'blankDisplay');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'blankDisplay() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'showDisplay',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'showDisplay()'),
                        this.socket.sendCommand(this.deviceId, 'showDisplay');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'showDisplay() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'suppressTouchScreen',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'suppressTouchScreen()'),
                        this.socket.sendCommand(this.deviceId, 'suppressTouchScreen');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'suppressTouchScreen() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'resumeTouchScreen',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'resumeTouchScreen()'),
                        this.socket.sendCommand(this.deviceId, 'resumeTouchScreen');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'resumeTouchScreen() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getScreenDiagonal',
                  value: function() {
                    try {
                      this.socket.sendRequest(this.deviceId, 'getScreenDiagonal'),
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'getScreenDiagonal(): ');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getScreenDiagonal() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'click',
                  value: function(e, t) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'click()'),
                        void 0 !== e && void 0 !== t
                          ? this.socket.sendCommand(this.deviceId, 'click', e, t)
                          : this.socket.sendCommand(this.deviceId, 'click', 1, 1);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'click() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'getStatusHeadset',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.statusHeadset() called' + e
                    ),
                      (this.device.headSetStatus = e);
                  },
                },
                {
                  key: 'getStatusKeypad',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.statusHeadset() called' + e
                    ),
                      (this.device.keypadStatus = e);
                  },
                },
                {
                  key: 'getStatusTTS',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.statusHeadset() called' + e
                    ),
                      (this.device.ttsStatus = e);
                  },
                },
                {
                  key: 'headsetInserted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.headsetInserted() called'),
                      (this.device.enabled = !0),
                      this.setEvent('enabled', !0);
                  },
                },
                {
                  key: 'isHeadsetAvailable',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.isHeadsetAvailable() called'
                    ),
                      (this.device.headsetAvailable = e);
                  },
                },
                {
                  key: 'headsetRemoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.headsetRemoved() called'),
                      (this.device.enabled = !1),
                      this.setEvent('enabled', !1);
                  },
                },
                {
                  key: 'keyPressed',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.keyPressed() called: ' + e),
                      this.setEvent('keyPressed', e);
                  },
                },
                {
                  key: 'speechCompleted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.speechCompleted() called'),
                      this.setEvent('speechCompleted', null);
                  },
                },
                {
                  key: 'speechPaused',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.speechPaused() called'),
                      this.setEvent('speechPaused', null);
                  },
                },
                {
                  key: 'speechStarted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.speechStarted() called'),
                      this.setEvent('speechStarted', null);
                  },
                },
                {
                  key: 'speechStopped',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.speechStopped() called'),
                      this.setEvent('speechStopped', null);
                  },
                },
                {
                  key: 'isAccessibilitySupported',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.isAccessibilitySupported() called: ' + e
                    );
                  },
                },
                {
                  key: 'play',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.play() called: ' + e);
                  },
                },
                {
                  key: 'enableKeypad',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.enableKeypad() called: ' + e
                    );
                  },
                },
                {
                  key: 'enableTTS',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'CUSSAccessibilityListener.enableTTS called: ' + e);
                  },
                },
                {
                  key: 'confirmAccessibleMode',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'CUSSAccessibilityListener.confirmAccessibleMode called: ' + e
                    );
                  },
                },
                {
                  key: 'getHeadsetDeviceHelp',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'Listener.getHeadsetDeviceHelp() ' + this.device.name),
                      this.setEvent('getHeadsetDeviceHelp', e);
                  },
                },
                {
                  key: 'getKeypadDeviceHelp',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'Listener.getKeypadDeviceHelp() ' + this.device.name),
                      this.setEvent('getKeypadDeviceHelp', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(22),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'AEA Bagdrop'), (i.deviceId = c.deviceIds.AEA_BAGDROP), i.setListener(new h.default()), i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'sendAEA',
                  value: function(e, t) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'sendAEA(): ' + e + ' timeout: ' + t),
                        this.socket.sendRequest(this.deviceId, 'sendAEA', e, t);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'sendAEA() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setupAEA',
                  value: function(e, t) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'setupAEA(): ' + e + ' timeout: ' + t),
                        this.socket.sendRequest(this.deviceId, 'setupAEA', e, t);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setupAEA() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'commandCompleted',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'AEABagdropListener.commandCompleted() called'),
                      this.setEvent('commandCompleted', e);
                  },
                },
                {
                  key: 'unsolicitedMessage',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'AEABagdropListener.unsolicitedMessage() called'),
                      this.setEvent('unsolicitedMessage', e);
                  },
                },
                {
                  key: 'sendAEA',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'AEABagdropListener.sendAEA() called'),
                      this.setEvent('sendAEA', e);
                  },
                },
                {
                  key: 'setupAEA',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'AEABagdropListener.setupAEA() called'),
                      this.setEvent('setupAEA', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(24),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Face Tracking'), (i.deviceId = c.deviceIds.FACE_TRACKING), i.setListener(new h.default()), i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'show',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'show(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'show', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'show() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'hide',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'hide(): '),
                        this.socket.sendRequest(this.deviceId, 'hide');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'hide() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'analyze',
                  value: function(e, t, s) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'analyze(): image1: '),
                        void 0 === t && void 0 === s
                          ? this.socket.sendRequest(this.deviceId, 'analyze', e)
                          : this.socket.sendRequest(this.deviceId, 'analyze', e, t, s);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'analyze() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enable',
                  value: function(e, t, s) {
                    try {
                      if (void 0 === e && void 0 === t) {
                        this.logMessage(c.TraceLevels.LOG_TRACE, 'enable(): ' + this.deviceId),
                          this.socket.sendRequest(this.deviceId, 'enable');
                      } else {
                        void 0 === s && (s = 0);
                        var i = void 0 !== e ? e.substring(0, 4) : '',
                          n = void 0 !== t ? t.substring(0, 4) : '';
                        this.logMessage(
                          c.TraceLevels.LOG_TRACE,
                          'enable()' + this.deviceId + ' mrz: ' + i + ' rfMrz: ' + n + 'okPhotoThreshold: ' + s
                        ),
                          this.socket.sendCommand(this.deviceId, 'enable', e, t, s);
                      }
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enable() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'clearSharedData',
                  value: function() {
                    this.logMessage(c.TraceLevels.LOG_TRACE, 'clearSharedData()'),
                      this.socket.sendCommand(this.deviceId, 'clearSharedData');
                  },
                },
                {
                  key: 'toggleView',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'toggleView(): '),
                        this.socket.sendRequest(this.deviceId, 'toggleView');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'toggleView() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'switchView',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'switchView(): ' + (void 0 === e ? '' : e)),
                        this.socket.sendRequest(this.deviceId, 'switchView', void 0 === e ? '' : e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'switchView() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'selectCamera',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'selectCamera(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'selectCamera', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'selectCamera() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'focusApp',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'focusApp()'),
                        this.socket.sendCommand(this.deviceId, 'focusApp');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'focusApp() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'faceAbsent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.faceAbsent() called'),
                      this.setEvent('faceAbsent');
                  },
                },
                {
                  key: 'facePresent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.facePresent() called'),
                      this.setEvent('facePresent');
                  },
                },
                {
                  key: 'pictureTaken',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.pictureTaken() called'),
                      this.setEvent('pictureTaken', e);
                  },
                },
                {
                  key: 'trackingEvent',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.trackingEvent() called'),
                      this.setEvent('trackingEvent', e);
                  },
                },
                {
                  key: 'dataError',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.dataError() called'),
                      this.setEvent('dataError', e);
                  },
                },
                {
                  key: 'analyze',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.analyze() called'),
                      this.setEvent('analyze', e);
                  },
                },
                {
                  key: 'analyzeResult',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.analyzeResult() called'),
                      this.setEvent('analyzeResult', e);
                  },
                },
                {
                  key: 'show',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.show() called'),
                      this.setEvent('show', e);
                  },
                },
                {
                  key: 'hide',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.hide() called'),
                      this.setEvent('hide', e);
                  },
                },
                {
                  key: 'toggleView',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.toggleView() called'),
                      this.setEvent('toggleView', e);
                  },
                },
                {
                  key: 'switchView',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.switchView() called'),
                      this.setEvent('switchView', e);
                  },
                },
                {
                  key: 'selectCamera',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.selectCamera() called'),
                      this.setEvent('selectCamera', e);
                  },
                },
                {
                  key: 'countDown',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.countDown() called'),
                      this.setEvent('countDown', e);
                  },
                },
                {
                  key: 'faceDescriptor',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.faceDescriptor() called'),
                      this.setEvent('faceDescriptor', e);
                  },
                },
                {
                  key: 'enable',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.enable() called'),
                      this.setEvent('enable', e);
                  },
                },
                {
                  key: 'disable',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FaceTrackingListener.disable() called'),
                      this.setEvent('disable', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(7),
          l = i(c),
          u = s(2),
          d = s(26),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Laser Printer'), (i.deviceId = u.deviceIds.LASER_PRINTER), i.setListener(new h.default()), i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'printFileByteStream',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printFileByteStream(): called'),
                        this.socket.sendRequest(this.deviceId, 'printFileByteStream', e, !1);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printFileByteStream() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printFileByteStreamBase64',
                  value: function(e) {
                    try {
                      this.logMessage(u.TraceLevels.LOG_TRACE, 'printFileByteStreamBase64(): called'),
                        this.socket.sendRequest(this.deviceId, 'printFileByteStream', e, !0);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printFileByteStream() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printImageStream',
                  value: function(e, t, s) {
                    try {
                      this.logMessage(
                        u.TraceLevels.LOG_TRACE,
                        'printImageStream(): called timeout: ' + t + ' toneScale: ' + s
                      ),
                        void 0 === t && (t = 2e4),
                        void 0 === s
                          ? this.socket.sendCommand(this.deviceId, 'printImageStream', e, t)
                          : this.socket.sendCommand(this.deviceId, 'printImageStream', e, t, s);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printImageStream() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'printPDFStream',
                  value: function(e, t, s, i, n, a) {
                    try {
                      this.logMessage(
                        u.TraceLevels.LOG_TRACE,
                        'printPDFStream(): called timeout: ' +
                          t +
                          ' formHeight: ' +
                          s +
                          ' formWidth: ' +
                          i +
                          ' xMargin: ' +
                          n +
                          ' printOptions: ' +
                          a
                      ),
                        void 0 === t
                          ? this.socket.sendCommand(this.deviceId, 'printPDFStream', e)
                          : void 0 === s
                          ? this.socket.sendCommand(this.deviceId, 'printPDFStream', e, t)
                          : void 0 === i
                          ? this.socket.sendCommand(this.deviceId, 'printPDFStream', e, t, s)
                          : void 0 === n
                          ? this.socket.sendCommand(this.deviceId, 'printPDFStream', e, t, s, i)
                          : void 0 === a
                          ? this.socket.sendCommand(this.deviceId, 'printPDFStream', e, t, s, i, n)
                          : this.socket.sendCommand(this.deviceId, 'printPDFStream', e, t, s, i, n, a);
                    } catch (e) {
                      this.logMessage(u.TraceLevels.LOG_ALERT, 'printPDFStream() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'pagePrintComplete',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.pagePrintComplete() called index: totalPages: ' + e
                    ),
                      this.setEvent('pagePrintComplete', e);
                  },
                },
                {
                  key: 'pagePrintFailed',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.pagePrintFailed() called index: totalPages: ' + e
                    ),
                      this.setEvent('pagePrintFailed', e);
                  },
                },
                {
                  key: 'pagePrinted',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.pagePrinted() called isPaperNormal: isPaperLow: ' + e
                    ),
                      this.setEvent('pagePrinted', e);
                  },
                },
                {
                  key: 'printerError',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.printerError() called returnCode: description: isFatal: ' + e
                    ),
                      this.setEvent('printerError', e);
                  },
                },
                {
                  key: 'printerTrayStatusChanged',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.printerTrayStatusChanged() called trayNumber: trayStatus: ' + e
                    ),
                      this.setEvent('printerTrayStatusChanged', e);
                  },
                },
                {
                  key: 'printFileByteStream',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.printFileByteStream() called rc: ' + e
                    ),
                      this.setEvent('printFileByteStream', e);
                  },
                },
                {
                  key: 'printImageStream',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.printImageStream() called rc: ' + e
                    ),
                      this.setEvent('printImageStream', e);
                  },
                },
                {
                  key: 'pagePrintFailure',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'LaserPrinterListener.pagePrintFailure() called errorDescr: rc: ' + e
                    ),
                      this.setEvent('pagePrintFailure', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(28),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Fingerprint Scanner'),
                (i.deviceId = c.deviceIds.FINGERPRINT_SCANNER),
                i.setListener(new h.default()),
                i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'setup',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'setup(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'setup', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setup() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getVersion',
                  value: function(e) {
                    try {
                      e
                        ? (this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'getVersion(): ' + e),
                          this.socket.sendRequest(this.deviceId, 'getVersion', e))
                        : (this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'getVersion()'),
                          this.socket.sendRequest(this.deviceId, 'getVersion'));
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getVersion() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'show',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'show(): ' + this.deviceId),
                        this.socket.sendRequest(this.deviceId, 'show');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'show() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'hide',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'hide(): ' + this.deviceId),
                        this.socket.sendRequest(this.deviceId, 'hide');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'hide() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enable',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'enable(): ' + this.deviceId),
                        this.socket.sendRequest(this.deviceId, 'enable');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enable() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'dataAvailable',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.dataAvailable() called'),
                      this.setEvent('dataAvailable', e);
                  },
                },
                {
                  key: 'mediaPresent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.mediaPresent() called'),
                      this.setEvent('mediaPresent', null);
                  },
                },
                {
                  key: 'mediaAbsent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.mediaAbsent() called'),
                      this.setEvent('mediaAbsent', null);
                  },
                },
                {
                  key: 'processing',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.processing() called'),
                      this.setEvent('processing', null);
                  },
                },
                {
                  key: 'dataError',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.dataError() called: ' + e);
                    var t = u.FingerPrintScannerErrors.DATA_ERROR_ERROR_UNKNOWN;
                    try {
                      t = parseInt(e, 10);
                    } catch (t) {
                      this.logMessage(
                        u.TraceLevels.LOG_EXT_TRACE,
                        'FingerPrintScannerListener.dataError() error parsing: ' + e
                      );
                    }
                    this.setEvent('dataError', t);
                  },
                },
                {
                  key: 'setup',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.setup() called'),
                      this.setEvent('setup', e);
                  },
                },
                {
                  key: 'getVersion',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.getVersion() called'),
                      this.setEvent('getVersion', e);
                  },
                },
                {
                  key: 'show',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.show() called'),
                      this.setEvent('show', e);
                  },
                },
                {
                  key: 'hide',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'FingerPrintScannerListener.hide() called'),
                      this.setEvent('hide', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(30),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (
                (i.name = 'Iris Camera'), (i.deviceId = c.deviceIds.IRIS_CAMERA), i.setListener(new h.default()), i
              );
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'setup',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'setup(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'setup', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setup() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'getVersion',
                  value: function(e) {
                    try {
                      e
                        ? (this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'getVersion(): ' + e),
                          this.socket.sendRequest(this.deviceId, 'getVersion', e))
                        : (this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'getVersion()'),
                          this.socket.sendRequest(this.deviceId, 'getVersion'));
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'getVersion() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setLanguage',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'setLanguage(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'setDeviceLanguage', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setLanguage() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'captureIris',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'captureIris().'),
                        this.socket.sendRequest(this.deviceId, 'irisCameraCapture');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'captureIris() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'enrollIris',
                  value: function(e, t, s, i) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'enrollIris(): ' + e + ' ' + t + ' ' + s + ' ' + i),
                        this.socket.sendRequest(this.deviceId, 'irisCameraEnroll', e, t, s, i);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'enrollIris() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'recognizeIris',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'recognizeIris().'),
                        this.socket.sendRequest(this.deviceId, 'irisCameraRecognize');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'recognizeIris() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'irisCameraDeleteDB',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'irisCameraDeleteDB().'),
                        this.socket.sendRequest(this.deviceId, 'irisCameraDeleteDB');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'irisCameraDeleteDB() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'dataAvailable',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.dataAvailable() called'),
                      this.setEvent('dataAvailable', e);
                  },
                },
                {
                  key: 'mediaPresent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.mediaPresent() called'),
                      this.setEvent('mediaPresent', null);
                  },
                },
                {
                  key: 'mediaAbsent',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.mediaAbsent() called'),
                      this.setEvent('mediaAbsent', null);
                  },
                },
                {
                  key: 'dataError',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.dataError() called: ' + e);
                    var t = u.IrisCameraErrors.DATA_ERROR_ERROR_UNKNOWN;
                    try {
                      t = parseInt(e, 10);
                    } catch (t) {
                      this.logMessage(
                        u.TraceLevels.LOG_EXT_TRACE,
                        'IrisCameraListener.dataError() error parsing: ' + e
                      );
                    }
                    this.setEvent('dataError', t);
                  },
                },
                {
                  key: 'setup',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.setup() called'),
                      this.setEvent('setup', e);
                  },
                },
                {
                  key: 'getVersion',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.getVersion() called'),
                      this.setEvent('getVersion', e);
                  },
                },
                {
                  key: 'imageStatus',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.imageStatus() called: ' + e),
                      this.setEvent('imageStatus', e);
                  },
                },
                {
                  key: 'playAudio',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.playAudio() called: ' + e),
                      this.setEvent('playAudio', e);
                  },
                },
                {
                  key: 'irisCameraCapture',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.irisCameraCapture() called: ' + e),
                      this.setEvent('irisCameraCapture', e);
                  },
                },
                {
                  key: 'irisCameraEnroll',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.irisCameraEnroll() called: ' + e),
                      this.setEvent('irisCameraEnroll', e);
                  },
                },
                {
                  key: 'irisCameraRecognize',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'IrisCameraListener.irisCameraRecognize() called: ' + e
                    ),
                      this.setEvent('irisCameraRecognize', e);
                  },
                },
                {
                  key: 'captureStatus',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.captureStatus() called: ' + e),
                      this.setEvent('captureStatus', e);
                  },
                },
                {
                  key: 'lensStatus',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.lensStatus() called: ' + e),
                      this.setEvent('lensStatus', e);
                  },
                },
                {
                  key: 'captureCompleted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.captureCompleted() called.'),
                      this.setEvent('captureCompleted');
                  },
                },
                {
                  key: 'getRange',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.getRange() called: ' + e),
                      this.setEvent('getRange', e);
                  },
                },
                {
                  key: 'captureAborted',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.captureAborted() called.'),
                      this.setEvent('captureAborted');
                  },
                },
                {
                  key: 'captureFailed',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.captureFailed() called.'),
                      this.setEvent('captureFailed');
                  },
                },
                {
                  key: 'irisCameraDeleteDB',
                  value: function(e) {
                    this.logMessage(
                      u.TraceLevels.LOG_EXT_TRACE,
                      'IrisCameraListener.irisCameraDeleteDB() called. ' + e
                    ),
                      this.setEvent('irisCameraDeleteDB');
                  },
                },
                {
                  key: 'setDeviceLanguage',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'IrisCameraListener.setDeviceLanguage() called. ' + e),
                      this.setEvent('setDeviceLanguage');
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(2),
          l = s(7),
          u = i(l),
          d = s(32),
          h = i(d),
          v = (function(e) {
            function t(e, s) {
              n(this, t);
              var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, s));
              return (i.name = 'eGate'), (i.deviceId = c.deviceIds.EGATE), i.setListener(new h.default()), i;
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'openGate',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'openGate().'),
                        this.socket.sendCommand(this.deviceId, 'openGate');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'openGate() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'closeGate',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'closeGate().'),
                        this.socket.sendCommand(this.deviceId, 'closeGate');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'closeGate() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'openGateForPax',
                  value: function() {
                    try {
                      this.logMessage(c.TraceLevels.LOG_TRACE, 'openGateForPax().'),
                        this.socket.sendRequest(this.deviceId, 'openGateForPax');
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'openGateForPax() exception: ' + e);
                    }
                  },
                },
                {
                  key: 'setup',
                  value: function(e) {
                    try {
                      this.logMessage(c.TraceLevels.LOG_EXT_TRACE, 'setup(): ' + e),
                        this.socket.sendRequest(this.deviceId, 'setup', e);
                    } catch (e) {
                      this.logMessage(c.TraceLevels.LOG_ALERT, 'setup() exception: ' + e);
                    }
                  },
                },
              ]),
              t
            );
          })(u.default);
        (t.default = v), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        function a(e, t) {
          if (!e) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
        }

        function r(e, t) {
          if ('function' != typeof t && null !== t) {
            throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          }
          (e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
            t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var o = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          c = s(5),
          l = i(c),
          u = s(2),
          d = (function(e) {
            function t() {
              return n(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }

            return (
              r(t, e),
              o(t, [
                {
                  key: 'openGateForPax',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.openGateForPax() called'),
                      this.setEvent('openGateForPax', e);
                  },
                },
                {
                  key: 'eGatePassengerFraud',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePassengerFraud() called'),
                      this.setEvent('eGatePassengerFraud', e);
                  },
                },
                {
                  key: 'eGatePassengerEntered',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePassengerEntered() called'),
                      this.setEvent('eGatePassengerEntered', null);
                  },
                },
                {
                  key: 'eGatePassengerLeft',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePassengerLeft() called'),
                      this.setEvent('eGatePassengerLeft', null);
                  },
                },
                {
                  key: 'eGatePassengerMoved',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePassengerMoved() called'),
                      this.setEvent('eGatePassengerMoved', null);
                  },
                },
                {
                  key: 'eGateDoorException',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateDoorException() called'),
                      this.setEvent('eGateDoorException', e);
                  },
                },
                {
                  key: 'eGateCriticalError',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateCriticalError() called'),
                      this.setEvent('eGateCriticalError', null);
                  },
                },
                {
                  key: 'eGateLostConnection',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateLostConnection() called'),
                      this.setEvent('eGateLostConnection', null);
                  },
                },
                {
                  key: 'eGatePaxProcessedOK',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePaxProcessedOK() called'),
                      this.setEvent('eGatePaxProcessedOK', null);
                  },
                },
                {
                  key: 'eGatePaxProcessedError',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGatePaxProcessedError() called'),
                      this.setEvent('eGatePaxProcessedError', null);
                  },
                },
                {
                  key: 'eGateClosed',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateClosed() called'),
                      this.setEvent('eGateClosed', null);
                  },
                },
                {
                  key: 'eGateStatusChange',
                  value: function() {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateStatusChange() called'),
                      this.setEvent('eGateStatusChange', null);
                  },
                },
                {
                  key: 'eGateUnknownState',
                  value: function(e) {
                    this.logMessage(u.TraceLevels.LOG_EXT_TRACE, 'EGateListener.eGateUnknownState() called'),
                      this.setEvent('eGateUnknownState', e);
                  },
                },
              ]),
              t
            );
          })(l.default);
        (t.default = d), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var a = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          r = s(34),
          o = i(r),
          c = s(2),
          l = s(35),
          u = s(6),
          d = s(38),
          h = i(d),
          v = (function() {
            function e(t, s, i, a, r, c) {
              n(this, e),
                (this.authenticationUrl = t),
                (this.heartbeatUrl = s),
                (this.deviceManager = i),
                (this.onAuthenticationCompleted = a),
                (this.onInService = r),
                (this.onOutOfService = c),
                (this.clientType = ''),
                (this.appVersion = ''),
                (this.locale = ''),
                (this.carrierCode = ''),
                (this.emptyDevices = []),
                (this.heartbeat = null),
                (this.authRetryDelay = 1e4),
                (this.deviceAvailTimeout = 3e4),
                (this.deviceUnavailTimeout = 3e4),
                (this.heartbeatAvailTimeout = 3e5),
                (this.heartbeatUnavailTimeout = 3e4),
                (this.maxInitialWait = 1e3),
                (this.heartbeatTimeout = 0),
                (this.deviceTimer = null),
                (this.deviceTimerTS = null),
                (this.deviceTimerTO = 0),
                (this.deviceTimerMaxDelta = 2e3),
                (this.startTimer = null),
                (this.heartbeatOK = !0),
                (this.devicesOK = !1),
                (this.inService = !1),
                (this.isStarted = !1),
                (this.isHBResponseInService = null),
                (this.serverDataUpdate = null),
                (this.statuses = {}),
                (this.isOK = {}),
                (this.checkDeviceActive = !1),
                (this.componentRC = new o.default()),
                (this.serverTimeDeltaMaxDiff = 1e3),
                (this.serverTimeDeltaMinChange = 100),
                (this.firstAvailDelay = 0),
                (this.logIt = null),
                (this.firstAvail = !0);
            }

            return (
              a(e, [
                {
                  key: 'setHeartbeatTimeout',
                  value: function(e) {
                    (0, u.isInteger)(e) && (this.heartbeatTimeout = e);
                  },
                },
                {
                  key: 'start',
                  value: function(e, t, s, i, n) {
                    var a = this;
                    this.isStarted ||
                      (this.deviceManager.dmLog(
                        c.TraceLevels.LOG_SYSTEM,
                        '>>>>>>>>>>>>>> Starting OOSManager <<<<<<<<<<<<'
                      ),
                      (this.clientType = t),
                      (this.appVersion = s),
                      (this.locale = e),
                      (this.carrierCode = i),
                      (this.isStarted = !0),
                      (this.heartbeat = new h.default(this.deviceManager, this.heartbeatTimeout, e, t, s, i)),
                      (this.heartbeat.onOutOfService = this.checkStatus.bind(this)),
                      (this.heartbeat.onInService = this.checkStatus.bind(this)),
                      this.heartbeat.setUrl(this.heartbeatUrl),
                      this.heartbeat.setInterval(this.heartbeatUnavailTimeout),
                      this.heartbeat.setRetries(2),
                      this.heartbeat.setServerTimeDeltaMaxDiff(this.serverTimeDeltaMaxDiff),
                      this.heartbeat.setServerTimeDeltaMinChange(this.serverTimeDeltaMinChange),
                      (this.logIt = this._logmsg.bind(this)),
                      this.deviceManager.setOnRequiredDeviceOK(this._onRequiredDeviceOK.bind(this)),
                      this.isHBResponseInService && (this.heartbeat.isResponseInService = this.isHBResponseInService),
                      this.serverDataUpdate && (this.heartbeat.serverDataUpdate = this.serverDataUpdate),
                      (this.startTimer = setInterval(function() {
                        null != a.deviceManager.appManager.kioskId && null != a.deviceManager.appManager.location
                          ? (clearInterval(a.startTimer),
                            '' !== a.authenticationUrl ? a._authenticate() : a.heartbeat.start(n),
                            a._checkDevices())
                          : a.deviceManager.dmLog(
                              c.TraceLevels.LOG_SYSTEM,
                              'START - waiting for kioskId and location.'
                            );
                      }, 50)));
                  },
                },
                {
                  key: '_buildAuthenticate',
                  value: function() {
                    return (
                      this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, 'buildAuthenticate'),
                      {
                        action: 'CONFIRM',
                        clientDetail: {
                          location: this.deviceManager.appManager.location,
                          clientID: this.deviceManager.appManager.kioskId,
                          clientTime: new Date(),
                          kmClientID: this.deviceManager.appManager.smKioskId,
                          selectedLanguage: this.locale,
                          clientType: this.clientType,
                          appVersion: this.appVersion,
                          carrierCode: this.carrierCode,
                        },
                        key: '',
                      }
                    );
                  },
                },
                {
                  key: '_authenticate',
                  value: function() {
                    var e = this;
                    this.deviceManager.dmLog(
                      c.TraceLevels.LOG_SYSTEM,
                      'OOS.authenticate url:[' + this.authenticationUrl + ']'
                    ),
                      (0, l.fetchWithTimeout)(
                        this.authenticationUrl,
                        this._buildAuthenticate(),
                        this.heartbeatTimeout,
                        this.logIt
                      )
                        .then(function(t) {
                          e.deviceManager.dmLog(
                            c.TraceLevels.LOG_SYSTEM,
                            'OOS.authenticate response: ' + JSON.stringify(t)
                          ),
                            e._authSuccess(t);
                        })
                        .catch(function(t) {
                          e.deviceManager.dmLog(c.TraceLevels.LOG_SYSTEM, 'OOS.authenticate Catch: ' + t),
                            e._authFailed(t);
                        });
                  },
                },
                {
                  key: '_authSuccess',
                  value: function(e) {
                    this.deviceManager.dmLog(c.TraceLevels.LOG_SYSTEM, 'Authentication response'),
                      this.onAuthenticationCompleted(e)
                        ? (this.deviceManager.dmLog(c.TraceLevels.LOG_SYSTEM, 'Authentication success'),
                          this.heartbeat.start())
                        : (this.deviceManager.dmLog(
                            c.TraceLevels.LOG_SYSTEM,
                            'Authentication failed - onAuthenticationCompleted returned false - retry after: ' +
                              this.authRetryDelay
                          ),
                          this.deviceManager.appManager.unavailable(),
                          setTimeout(this._authenticate.bind(this), this.authRetryDelay));
                  },
                },
                {
                  key: '_authFailed',
                  value: function(e) {
                    this.deviceManager.dmLog(
                      c.TraceLevels.LOG_SYSTEM,
                      'Authentication failed: ' + e + ' retry after: ' + this.authRetryDelay
                    ),
                      this.deviceManager.appManager.unavailable(),
                      setTimeout(this._authenticate.bind(this), this.authRetryDelay);
                  },
                },
                {
                  key: '_onAuthenticationCompletedDefault',
                  value: function(e) {
                    return (
                      this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, 'OOS.onAuthenticationCompleted default'), !0
                    );
                  },
                },
                {
                  key: '_checkDevices',
                  value: function() {
                    var e = this;
                    return (
                      this.deviceManager.dmLog(
                        c.TraceLevels.LOG_LEVEL2,
                        'OOS.checkDevices *****************************'
                      ),
                      this.deviceManager.noWebsocket === !0
                        ? void (this.devicesOK = !0)
                        : void this.deviceManager.appManager
                            .getCurrentState(c.RETURN_PROMISE)
                            .then(function(t) {
                              var s = parseInt(t, 10);
                              if (
                                (e.deviceManager.dmLog(
                                  c.TraceLevels.LOG_TRACE,
                                  '.OOS.checkDevices appState = ' +
                                    s +
                                    ' [' +
                                    (0, u.getKeyByValue)(c.ApplicationState, s) +
                                    '] checkDeviceActive = ' +
                                    e.checkDeviceActive
                                ),
                                s === c.ApplicationState.ACTIVE && !e.checkDeviceActive)
                              ) {
                                return void e.deviceManager.dmLog(
                                  c.TraceLevels.LOG_SYSTEM,
                                  "OOS.checkDevices application is active...when we go available we'll start again."
                                );
                              }
                              for (
                                var i = e.deviceManager.devices,
                                  n = i.length,
                                  a = function(t) {
                                    e.deviceManager.dmLog(
                                      c.TraceLevels.LOG_EXT_TRACE,
                                      '..OOS.checkDevices device: ' + i[t].name
                                    ),
                                      i[t]
                                        .statusIsOK(c.RETURN_PROMISE)
                                        .then(function(a) {
                                          var r = i[t].deviceStatus,
                                            o = i[t].isDeviceOk;
                                          e.deviceManager.dmLog(
                                            c.TraceLevels.LOG_EXT_TRACE,
                                            '..OOS.checkDevices device:[' +
                                              i[t].name +
                                              '] isDeviceOK: [' +
                                              o +
                                              '] status: [' +
                                              r +
                                              ']'
                                          ),
                                            n--,
                                            0 === n && e._checkDevices2(s);
                                        })
                                        .catch(function(t) {
                                          e.deviceManager.dmLog(
                                            c.TraceLevels.LOG_ALERT,
                                            '..OOS.checkDevices statusIsOK error: ' + t
                                          ),
                                            t === c.PromiseCodes.TIMEOUT && (n--, 0 === n && e._checkDevices2(s));
                                        });
                                  },
                                  r = 0;
                                r < i.length;
                                r++
                              ) {
                                a(r);
                              }
                            })
                            .catch(function(t) {
                              e.deviceManager.dmLog(
                                c.TraceLevels.LOG_ALERT,
                                '..OOS.checkDevices getCurrentState error: ' + t
                              ),
                                t === c.PromiseCodes.TIMEOUT && ((e.devicesOK = !1), e._checkDevices2(2));
                            })
                    );
                  },
                },
                {
                  key: '_checkDevices2',
                  value: function(e) {
                    this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, 'OOS.checkDevices2.');
                    for (
                      var t = '', s = this.devicesOK, i = !0, n = this.deviceManager.devices, a = 0;
                      a < n.length;
                      a++
                    ) {
                      this.deviceManager.dmLog(c.TraceLevels.LOG_EXT_TRACE, '..OOS.checkDevices2 device: ' + n[a].name);
                      var r = n[a].deviceStatus,
                        o = n[a].isDeviceOk;
                      this.deviceManager.dmLog(
                        c.TraceLevels.LOG_EXT_TRACE,
                        '..OOS.checkDevices2 device:[' + n[a].name + '] isDeviceOK: [' + o + '] status: [' + r + ']'
                      ),
                        o &&
                          this.emptyDevices.indexOf(n[a].deviceId) >= 0 &&
                          (e === c.ApplicationState.ACTIVE ||
                            (r !== this.componentRC.MEDIAFULL &&
                              r !== this.componentRCMEDIAHIGH &&
                              r !== this.componentRC.MEDIAPRESENT) ||
                            (this.deviceManager.dmLog(
                              c.TraceLevels.LOG_EXT_TRACE,
                              '..OOS.checkDevices2 ' + n[a].name + ' still has documents or media inserted!'
                            ),
                            (o = !1))),
                        !o && n[a].isRequired
                          ? ((this.devicesOK = !1), (i = !1), (t += n[a].name + ' not OK! '))
                          : (t += o ? n[a].name + ' OK. ' : n[a].name + ' (not OK) ');
                    }
                    (this.devicesOK = i),
                      this.deviceManager.dmLog(c.TraceLevels.LOG_SYSTEM, 'OOS.checkDevices2 ----> ' + t),
                      s && !this.devicesOK && this._kmLog(8, 'Transaction aborted - device error');
                    var l = this.deviceAvailTimeout;
                    this.inService || (l = this.deviceUnavailTimeout),
                      this.deviceManager.dmLog(
                        c.TraceLevels.LOG_SYSTEM,
                        'OOS.checkDevices2 appinservice: ' + this.inService + ' timer: ' + l
                      ),
                      this.deviceTimer && clearTimeout(this.deviceTimer),
                      (this.deviceTimerTS = new Date()),
                      (this.deviceTimerTO = l),
                      (this.deviceTimer = setTimeout(this._checkDevices.bind(this), l)),
                      e !== c.ApplicationState.INITIALIZE ||
                        this.inService ||
                        this.deviceManager.appManager.unavailable(),
                      this.checkStatus();
                  },
                },
                {
                  key: 'checkStatus',
                  value: function() {
                    var e = this;
                    this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, 'OOS.checkStatus'),
                      this.deviceManager.logMemoryUsage(),
                      this.deviceManager.appManager
                        .getCurrentState(c.RETURN_PROMISE, this.deviceManager.noWebsocket === !0)
                        .then(function(t) {
                          var s = parseInt(t, 10),
                            i = e.deviceManager.appManager;
                          (e.heartbeatOK = e.heartbeat.isInService()),
                            e.deviceManager.dmLog(
                              c.TraceLevels.LOG_SYSTEM,
                              '----->OOS.checkStatus=> appState: ' +
                                s +
                                ' devicesOK:' +
                                e.devicesOK +
                                ', heartbeatOK:' +
                                e.heartbeatOK +
                                ', inService:' +
                                e.inService +
                                ' ***'
                            ),
                            e.devicesOK && e.heartbeatOK && !e.inService
                              ? ((e.inService = !0),
                                e.deviceManager.dmLog(
                                  c.TraceLevels.LOG_SYSTEM,
                                  '.OOS.checkStatus -> Application going into service.'
                                ),
                                e.firstAvail && 0 !== e.firstAvailDelay
                                  ? ((e.firstAvail = !1),
                                    setTimeout(function() {
                                      e._kmLog(300, 'Application in service'),
                                        i.available(),
                                        e.heartbeat.setInterval(e.heartbeatAvailTimeout),
                                        e.deviceManager.dmLog(
                                          c.TraceLevels.LOG_TRACE,
                                          '.OOS.checkStatus -> call this.onInService'
                                        ),
                                        setTimeout(e.onInService, 100);
                                    }, 1e3 * e.firstAvailDelay))
                                  : (e._kmLog(300, 'Application in service'),
                                    i.available(),
                                    e.heartbeat.setInterval(e.heartbeatAvailTimeout),
                                    e.deviceManager.dmLog(
                                      c.TraceLevels.LOG_TRACE,
                                      '.OOS.checkStatus -> call this.onInService'
                                    ),
                                    setTimeout(e.onInService, 100)))
                              : (e.devicesOK && e.heartbeatOK) ||
                                (!e.inService && s !== c.ApplicationState.AVAILABLE) ||
                                ((e.inService = !1),
                                e.deviceManager.dmLog(
                                  c.TraceLevels.LOG_SYSTEM,
                                  '.OOS.checkStatus -> Application going out of service.'
                                ),
                                e._kmLog(301, 'Application out of service'),
                                s === c.ApplicationState.ACTIVE
                                  ? e.onActiveOOS(!e.heartbeatOK)
                                  : (s !== c.ApplicationState.AVAILABLE && s !== c.ApplicationState.INITIALIZE) ||
                                    (i.unavailable(), setTimeout(e.onOutOfService, 100)),
                                e.heartbeat.setInterval(e.heartbeatUnavailTimeout));
                        })
                        .catch(function(t) {
                          e.deviceManager.dmLog(
                            c.TraceLevels.LOG_ALERT,
                            '.OOS.checkStatus getCurrentState error: ' + t
                          ),
                            t === c.PromiseCodes.TIMEOUT;
                        });
                  },
                },
                {
                  key: 'onActiveOOS',
                  value: function(e) {
                    e
                      ? (this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS.onActiveOOS -> application OOS because ETS is not available'
                        ),
                        this.completeTransaction(!0))
                      : (this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS.onActiveOOS -> application OOS because some devices are not available'
                        ),
                        this.completeTransaction(!1));
                  },
                },
                {
                  key: 'setEmptyDevices',
                  value: function() {
                    for (var e = arguments.length, t = Array(e), s = 0; s < e; s++) {
                      t[s] = arguments[s];
                    }
                    this.emptyDevices = [];
                    for (var i = 0; i < arguments.length; i++) {
                      this.emptyDevices.push(arguments[i]);
                    }
                  },
                },
                {
                  key: 'getHeartbeat',
                  value: function() {
                    return this.heartbeat;
                  },
                },
                {
                  key: 'setHeartbeatTime',
                  value: function(e) {
                    (0, u.isInteger)(e) && (this.heartbeatAvailTimeout = e);
                  },
                },
                {
                  key: 'setHeartbeatTimeUnavail',
                  value: function(e) {
                    (0, u.isInteger)(e) && (this.heartbeatUnavailTimeout = e);
                  },
                },
                {
                  key: 'setDeviceTime',
                  value: function(e) {
                    (0, u.isInteger)(e) && (this.deviceAvailTimeout = e);
                  },
                },
                {
                  key: 'setDeviceTimeUnavail',
                  value: function(e) {
                    (0, u.isInteger)(e) && (this.deviceUnavailTimeout = e);
                  },
                },
                {
                  key: 'isInService',
                  value: function() {
                    return this.inService;
                  },
                },
                {
                  key: 'isDevicesOK',
                  value: function() {
                    return this.devicesOK;
                  },
                },
                {
                  key: 'isHeartbeatOK',
                  value: function() {
                    return this.heartbeatOK;
                  },
                },
                {
                  key: 'completeTransaction',
                  value: function(e) {
                    if (
                      (this.deviceManager.dmLog(
                        c.TraceLevels.LOG_SYSTEM,
                        'OOS.completeTransaction start forceUnavailable: ' + e
                      ),
                      this.deviceManager.noWebsocket === !0)
                    ) {
                      return void this.deviceManager.dmLog(
                        c.TraceLevels.LOG_SYSTEM,
                        'OOS.completeTransaction exit: noWebsocket === true'
                      );
                    }
                    this.deviceTimer && (clearTimeout(this.deviceTimer), (this.deviceTimer = null));
                    var t = this.deviceManager.getAppManager();
                    this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, '.OOS.completeTransaction app manager.'),
                      this.inService && !e
                        ? (this.deviceManager.dmLog(
                            c.TraceLevels.LOG_TRACE,
                            '.OOS.completeTransaction() called. Going available.'
                          ),
                          t.available(),
                          (this.deviceTimerTS = new Date()),
                          (this.deviceTimerTO = this.deviceAvailTimeout),
                          (this.deviceTimer = setTimeout(this._checkDevices.bind(this), this.deviceAvailTimeout)))
                        : (e
                            ? ((this.devicesOK = !1),
                              (this.inService = !1),
                              this.deviceManager.dmLog(
                                c.TraceLevels.LOG_TRACE,
                                '.OOS.completeTransaction() called. Forcing app into unavailable state.'
                              ))
                            : this.heartbeatOK
                            ? this.deviceManager.dmLog(
                                c.TraceLevels.LOG_TRACE,
                                '.OOS.completeTransaction() called. Devices not OK, going unavailable.'
                              )
                            : this.devicesOK
                            ? this.deviceManager.dmLog(
                                c.TraceLevels.LOG_TRACE,
                                '.OOS.completeTransaction() called. Heartbeat not OK, going unavailable.'
                              )
                            : this.deviceManager.dmLog(
                                c.TraceLevels.LOG_TRACE,
                                '.OOS.completeTransaction() called. Devices and heartbeat not OK, going unavailable.'
                              ),
                          t.unavailable(),
                          this.heartbeat && this.heartbeat.setInterval(this.heartbeatUnavailTimeout),
                          (this.deviceTimerTS = new Date()),
                          (this.deviceTimerTO = this.deviceUnavailTimeout),
                          (this.deviceTimer = setTimeout(this._checkDevices.bind(this), this.deviceUnavailTimeout)));
                  },
                },
                {
                  key: 'setCheckDeviceActive',
                  value: function(e) {
                    this.checkDeviceActive = e;
                  },
                },
                {
                  key: 'onDeviceCheck',
                  value: function(e, t) {},
                },
                {
                  key: 'getDeviceStatus',
                  value: function(e) {
                    return this.statuses[e] || -1;
                  },
                },
                {
                  key: 'isDeviceOK',
                  value: function(e) {
                    this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, '.OOS.isDeviceOK() called: ' + e);
                    for (var t = this.deviceManager.devices, s = 0; s < t.length; s++) {
                      if (e === t[s].deviceId) {
                        return t[s].isDeviceOk;
                      }
                    }
                    return (
                      this.deviceManager.dmLog(
                        c.TraceLevels.LOG_TRACE,
                        '.OOS.isDeviceOK() device not found (return false): ' + e
                      ),
                      !1
                    );
                  },
                },
                {
                  key: '_kmLog',
                  value: function(e, t) {
                    this.deviceManager.appManager.sendApplicationLog(100, 'CDS_APPLOG,' + e + ', ' + t);
                  },
                },
                {
                  key: 'setIsHBResponseInService',
                  value: function(e) {
                    this.isHBResponseInService = e;
                  },
                },
                {
                  key: 'setServerDataUpdate',
                  value: function(e) {
                    this.serverDataUpdate = e;
                  },
                },
                {
                  key: '_logmsg',
                  value: function(e) {
                    this.deviceManager.dmLog(c.TraceLevels.LOG_TRACE, e);
                  },
                },
                {
                  key: '_onRequiredDeviceOK',
                  value: function(e) {
                    this.deviceManager.dmLog(c.TraceLevels.LOG_SYSTEM, 'OOS._onRequiredDeviceOK: ' + e);
                    var t = new Date();
                    this.deviceTimerTS > 0 &&
                    this.deviceTimerTO > 0 &&
                    t - this.deviceTimerTS < this.deviceTimerTO - this.deviceTimerMaxDelta
                      ? (this.deviceTimer && (clearTimeout(this.deviceTimer), (this.deviceTimer = null)),
                        (this.deviceTimerTS = new Date()),
                        (this.deviceTimerTO = 0),
                        (this.deviceTimer = setTimeout(this._checkDevices.bind(this), 0)))
                      : (this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: delta: ' +
                            (this.deviceTimerTS + this.deviceTimerTO - (t + this.deviceTimerMaxDelta))
                        ),
                        this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: elapsed: ' + (t - this.deviceTimerTS)
                        ),
                        this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: this.deviceTimerTS: ' + this.deviceTimerTS
                        ),
                        this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: this.deviceTimerTO: ' + this.deviceTimerTO
                        ),
                        this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: now:                ' + t
                        ),
                        this.deviceManager.dmLog(
                          c.TraceLevels.LOG_SYSTEM,
                          'OOS._onRequiredDeviceOK: this.deviceTimerMaxDelta: ' + this.deviceTimerMaxDelta
                        ));
                  },
                },
                {
                  key: 'setServerTimeDeltaMaxDiff',
                  value: function(e) {
                    this.serverTimeDeltaMaxDiff = e;
                  },
                },
                {
                  key: 'setServerTimeDeltaMinChange',
                  value: function(e) {
                    this.serverTimeDeltaMinChange = e;
                  },
                },
                {
                  key: 'setFirstAvailDelay',
                  value: function(e) {
                    this.firstAvailDelay = e;
                  },
                },
              ]),
              e
            );
          })();
        (t.default = v), (e.exports = t.default);
      },
      function(e, t) {
        'use strict';

        function s(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var i = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          n = (function() {
            function e() {
              s(this, e),
                (this.OK = 0),
                (this.TIMEOUT = 1),
                (this.CANCELLED = 3),
                (this.SEQUENCE_ERR = 5),
                (this.JAM = 101),
                (this.MEDIA_HIGH = 102),
                (this.MEDIA_PRESENT = 103),
                (this.MEDIA_ABSENT = 104),
                (this.MEDIA_SWIPE = 105),
                (this.MEDIA_FULL = 106),
                (this.MEDIA_LOW = 107),
                (this.MEDIA_EMPTY = 108),
                (this.MEDIA_DAMAGED = 109),
                (this.MEDIA_INCOMPLETE_INSERTION = 110),
                (this.FORMAT_ERROR = 201),
                (this.DATA_PRESENT = 205),
                (this.HW_ERROR = 302),
                (this.SW_ERROR = 303),
                (this.NOT_RESPONDING = 305),
                (this.CFG_ERROR = 308);
            }

            return (
              i(e, [
                {
                  key: 'getRCString',
                  value: function(e) {
                    switch (e) {
                      case this.OK:
                        return 'OK';
                      case this.TIMEOUT:
                        return 'Timed out';
                      case this.CANCELLED:
                        return 'Cancelled';
                      case this.SEQUENCE_ERR:
                        return 'Command sequence error';
                      case this.JAM:
                        return 'Jammed';
                      case this.MEDIA_PRESENT:
                        return 'media present or inserted';
                      case this.MEDIA_ABSENT:
                        return 'No media present and/or removed';
                      case this.MEDIA_INCOMPLETE_INSERTION:
                        return 'Incomplete insertion of media';
                      case this.FORMAT_ERROR:
                        return 'Format, parameter or length error';
                      case this.HW_ERROR:
                        return 'Hardware error';
                      case this.SW_ERROR:
                        return 'Software error';
                      case this.NOT_RESPONDING:
                        return 'Device not responding';
                      case this.CFG_ERROR:
                        return 'Configuration error';
                      case this.MEDIA_LOW:
                        return 'Media is low';
                      case this.MEDIA_EMPTY:
                        return 'Media is empty';
                      case this.MEDIA_DAMAGED:
                        return 'Media is damaged';
                      case this.DATA_PRESENT:
                        return 'Data Present';
                      case this.MEDIA_HIGH:
                        return 'Media High';
                      case this.MEDIA_FULL:
                        return 'Media Full';
                      case this.MEDIA_SWIPE:
                        return 'Media Swiped (deprecated)';
                    }
                    return '';
                  },
                },
              ]),
              e
            );
          })();
        (t.default = n), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e) {
          return e && e.__esModule ? e : { default: e };
        }

        function n(e) {
          var t = {};
          return (
            Object.getOwnPropertyNames(e).forEach(function(s) {
              t[s] = e[s];
            }),
            JSON.stringify(t)
          );
        }

        function a(e) {
          if (200 === e.status) {
            return e;
          }
          console.log('fetchStatusHandler:', e);
          var t = new Error(e.statusText);
          throw ((t.detail = e.status), (t.source = 'fetch'), console.log(n(t)), t);
        }

        function r() {
          var e = new Error('timeout');
          return (e.detail = 777), (e.source = 'fetch'), console.log(n(e)), e;
        }

        function o(e, t, s, i) {
          return (
            ((0, u.isInteger)(s) && 0 !== s) || (s = 6e4),
            void 0 !== i ? i('fetchWithTimeout: url:[' + e + ']') : console.log('fetchWithTimeout: url:[' + e + ']'),
            new Promise(function(n, o) {
              var c = setTimeout(function() {
                o(r());
              }, s);
              (0, l.default)(e, {
                method: 'POST',
                headers: new Headers({
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                }),
                mode: 'cors',
                body: JSON.stringify(t),
              })
                .then(function(e) {
                  return (
                    void 0 !== i && i('>> (FetchWithTimeout.js) .then(#1) - response = "' + e + '"'), clearTimeout(c), e
                  );
                })
                .then(a)
                .then(function(e) {
                  return n(e.json());
                })
                .catch(function(e) {
                  void 0 !== i && i('>> (FetchWithTimeout.js) Catch:' + e), clearTimeout(c), o(e);
                });
            })
          );
        }

        Object.defineProperty(t, '__esModule', { value: !0 }), (t.fetchWithTimeout = o);
        var c = s(36),
          l = i(c),
          u = s(6);
      },
      function(e, t, s) {
        s(37), (e.exports = self.fetch.bind(self));
      },
      function(e, t, s) {
        !(function(e, s) {
          s(t);
        })(this, function(e) {
          'use strict';

          function t(e) {
            return e && DataView.prototype.isPrototypeOf(e);
          }

          function s(e) {
            if (('string' != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))) {
              throw new TypeError('Invalid character in header field name');
            }
            return e.toLowerCase();
          }

          function i(e) {
            return 'string' != typeof e && (e = String(e)), e;
          }

          function n(e) {
            var t = {
              next: function() {
                var t = e.shift();
                return { done: void 0 === t, value: t };
              },
            };
            return (
              L.iterable &&
                (t[Symbol.iterator] = function() {
                  return t;
                }),
              t
            );
          }

          function a(e) {
            (this.map = {}),
              e instanceof a
                ? e.forEach(function(e, t) {
                    this.append(t, e);
                  }, this)
                : Array.isArray(e)
                ? e.forEach(function(e) {
                    this.append(e[0], e[1]);
                  }, this)
                : e &&
                  Object.getOwnPropertyNames(e).forEach(function(t) {
                    this.append(t, e[t]);
                  }, this);
          }

          function r(e) {
            return e.bodyUsed ? Promise.reject(new TypeError('Already read')) : void (e.bodyUsed = !0);
          }

          function o(e) {
            return new Promise(function(t, s) {
              (e.onload = function() {
                t(e.result);
              }),
                (e.onerror = function() {
                  s(e.error);
                });
            });
          }

          function c(e) {
            var t = new FileReader(),
              s = o(t);
            return t.readAsArrayBuffer(e), s;
          }

          function l(e) {
            var t = new FileReader(),
              s = o(t);
            return t.readAsText(e), s;
          }

          function u(e) {
            for (var t = new Uint8Array(e), s = new Array(t.length), i = 0; i < t.length; i++) {
              s[i] = String.fromCharCode(t[i]);
            }
            return s.join('');
          }

          function d(e) {
            if (e.slice) {
              return e.slice(0);
            }
            var t = new Uint8Array(e.byteLength);
            return t.set(new Uint8Array(e)), t.buffer;
          }

          function h() {
            return (
              (this.bodyUsed = !1),
              (this._initBody = function(e) {
                (this._bodyInit = e),
                  e
                    ? 'string' == typeof e
                      ? (this._bodyText = e)
                      : L.blob && Blob.prototype.isPrototypeOf(e)
                      ? (this._bodyBlob = e)
                      : L.formData && FormData.prototype.isPrototypeOf(e)
                      ? (this._bodyFormData = e)
                      : L.searchParams && URLSearchParams.prototype.isPrototypeOf(e)
                      ? (this._bodyText = e.toString())
                      : L.arrayBuffer && L.blob && t(e)
                      ? ((this._bodyArrayBuffer = d(e.buffer)), (this._bodyInit = new Blob([this._bodyArrayBuffer])))
                      : L.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || _(e))
                      ? (this._bodyArrayBuffer = d(e))
                      : (this._bodyText = e = Object.prototype.toString.call(e))
                    : (this._bodyText = ''),
                  this.headers.get('content-type') ||
                    ('string' == typeof e
                      ? this.headers.set('content-type', 'text/plain;charset=UTF-8')
                      : this._bodyBlob && this._bodyBlob.type
                      ? this.headers.set('content-type', this._bodyBlob.type)
                      : L.searchParams &&
                        URLSearchParams.prototype.isPrototypeOf(e) &&
                        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8'));
              }),
              L.blob &&
                ((this.blob = function() {
                  var e = r(this);
                  if (e) {
                    return e;
                  }
                  if (this._bodyBlob) {
                    return Promise.resolve(this._bodyBlob);
                  }
                  if (this._bodyArrayBuffer) {
                    return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                  }
                  if (this._bodyFormData) {
                    throw new Error('could not read FormData body as blob');
                  }
                  return Promise.resolve(new Blob([this._bodyText]));
                }),
                (this.arrayBuffer = function() {
                  return this._bodyArrayBuffer
                    ? r(this) || Promise.resolve(this._bodyArrayBuffer)
                    : this.blob().then(c);
                })),
              (this.text = function() {
                var e = r(this);
                if (e) {
                  return e;
                }
                if (this._bodyBlob) {
                  return l(this._bodyBlob);
                }
                if (this._bodyArrayBuffer) {
                  return Promise.resolve(u(this._bodyArrayBuffer));
                }
                if (this._bodyFormData) {
                  throw new Error('could not read FormData body as text');
                }
                return Promise.resolve(this._bodyText);
              }),
              L.formData &&
                (this.formData = function() {
                  return this.text().then(p);
                }),
              (this.json = function() {
                return this.text().then(JSON.parse);
              }),
              this
            );
          }

          function v(e) {
            var t = e.toUpperCase();
            return A.indexOf(t) > -1 ? t : e;
          }

          function T(e, t) {
            t = t || {};
            var s = t.body;
            if (e instanceof T) {
              if (e.bodyUsed) {
                throw new TypeError('Already read');
              }
              (this.url = e.url),
                (this.credentials = e.credentials),
                t.headers || (this.headers = new a(e.headers)),
                (this.method = e.method),
                (this.mode = e.mode),
                (this.signal = e.signal),
                s || null == e._bodyInit || ((s = e._bodyInit), (e.bodyUsed = !0));
            } else {
              this.url = String(e);
            }
            if (
              ((this.credentials = t.credentials || this.credentials || 'same-origin'),
              (!t.headers && this.headers) || (this.headers = new a(t.headers)),
              (this.method = v(t.method || this.method || 'GET')),
              (this.mode = t.mode || this.mode || null),
              (this.signal = t.signal || this.signal),
              (this.referrer = null),
              ('GET' === this.method || 'HEAD' === this.method) && s)
            ) {
              throw new TypeError('Body not allowed for GET or HEAD requests');
            }
            this._initBody(s);
          }

          function p(e) {
            var t = new FormData();
            return (
              e
                .trim()
                .split('&')
                .forEach(function(e) {
                  if (e) {
                    var s = e.split('='),
                      i = s.shift().replace(/\+/g, ' '),
                      n = s.join('=').replace(/\+/g, ' ');
                    t.append(decodeURIComponent(i), decodeURIComponent(n));
                  }
                }),
              t
            );
          }

          function f(e) {
            var t = new a(),
              s = e.replace(/\r?\n[\t ]+/g, ' ');
            return (
              s.split(/\r?\n/).forEach(function(e) {
                var s = e.split(':'),
                  i = s.shift().trim();
                if (i) {
                  var n = s.join(':').trim();
                  t.append(i, n);
                }
              }),
              t
            );
          }

          function g(e, t) {
            t || (t = {}),
              (this.type = 'default'),
              (this.status = void 0 === t.status ? 200 : t.status),
              (this.ok = this.status >= 200 && this.status < 300),
              (this.statusText = 'statusText' in t ? t.statusText : 'OK'),
              (this.headers = new a(t.headers)),
              (this.url = t.url || ''),
              this._initBody(e);
          }

          function E(t, s) {
            return new Promise(function(i, n) {
              function a() {
                o.abort();
              }

              var r = new T(t, s);
              if (r.signal && r.signal.aborted) {
                return n(new e.DOMException('Aborted', 'AbortError'));
              }
              var o = new XMLHttpRequest();
              (o.onload = function() {
                var e = {
                  status: o.status,
                  statusText: o.statusText,
                  headers: f(o.getAllResponseHeaders() || ''),
                };
                e.url = 'responseURL' in o ? o.responseURL : e.headers.get('X-Request-URL');
                var t = 'response' in o ? o.response : o.responseText;
                i(new g(t, e));
              }),
                (o.onerror = function() {
                  n(new TypeError('Network request failed'));
                }),
                (o.ontimeout = function() {
                  n(new TypeError('Network request failed'));
                }),
                (o.onabort = function() {
                  n(new e.DOMException('Aborted', 'AbortError'));
                }),
                o.open(r.method, r.url, !0),
                'include' === r.credentials
                  ? (o.withCredentials = !0)
                  : 'omit' === r.credentials && (o.withCredentials = !1),
                'responseType' in o && L.blob && (o.responseType = 'blob'),
                r.headers.forEach(function(e, t) {
                  o.setRequestHeader(t, e);
                }),
                r.signal &&
                  (r.signal.addEventListener('abort', a),
                  (o.onreadystatechange = function() {
                    4 === o.readyState && r.signal.removeEventListener('abort', a);
                  })),
                o.send('undefined' == typeof r._bodyInit ? null : r._bodyInit);
            });
          }

          var L = {
            searchParams: 'URLSearchParams' in self,
            iterable: 'Symbol' in self && 'iterator' in Symbol,
            blob:
              'FileReader' in self &&
              'Blob' in self &&
              (function() {
                try {
                  return new Blob(), !0;
                } catch (e) {
                  return !1;
                }
              })(),
            formData: 'FormData' in self,
            arrayBuffer: 'ArrayBuffer' in self,
          };
          if (L.arrayBuffer) {
            var y = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]',
              ],
              _ =
                ArrayBuffer.isView ||
                function(e) {
                  return e && y.indexOf(Object.prototype.toString.call(e)) > -1;
                };
          }
          (a.prototype.append = function(e, t) {
            (e = s(e)), (t = i(t));
            var n = this.map[e];
            this.map[e] = n ? n + ', ' + t : t;
          }),
            (a.prototype.delete = function(e) {
              delete this.map[s(e)];
            }),
            (a.prototype.get = function(e) {
              return (e = s(e)), this.has(e) ? this.map[e] : null;
            }),
            (a.prototype.has = function(e) {
              return this.map.hasOwnProperty(s(e));
            }),
            (a.prototype.set = function(e, t) {
              this.map[s(e)] = i(t);
            }),
            (a.prototype.forEach = function(e, t) {
              for (var s in this.map) {
                this.map.hasOwnProperty(s) && e.call(t, this.map[s], s, this);
              }
            }),
            (a.prototype.keys = function() {
              var e = [];
              return (
                this.forEach(function(t, s) {
                  e.push(s);
                }),
                n(e)
              );
            }),
            (a.prototype.values = function() {
              var e = [];
              return (
                this.forEach(function(t) {
                  e.push(t);
                }),
                n(e)
              );
            }),
            (a.prototype.entries = function() {
              var e = [];
              return (
                this.forEach(function(t, s) {
                  e.push([s, t]);
                }),
                n(e)
              );
            }),
            L.iterable && (a.prototype[Symbol.iterator] = a.prototype.entries);
          var A = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
          (T.prototype.clone = function() {
            return new T(this, { body: this._bodyInit });
          }),
            h.call(T.prototype),
            h.call(g.prototype),
            (g.prototype.clone = function() {
              return new g(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new a(this.headers),
                url: this.url,
              });
            }),
            (g.error = function() {
              var e = new g(null, { status: 0, statusText: '' });
              return (e.type = 'error'), e;
            });
          var O = [301, 302, 303, 307, 308];
          (g.redirect = function(e, t) {
            if (O.indexOf(t) === -1) {
              throw new RangeError('Invalid status code');
            }
            return new g(null, { status: t, headers: { location: e } });
          }),
            (e.DOMException = self.DOMException);
          try {
            new e.DOMException();
          } catch (t) {
            (e.DOMException = function(e, t) {
              (this.message = e), (this.name = t);
              var s = Error(e);
              this.stack = s.stack;
            }),
              (e.DOMException.prototype = Object.create(Error.prototype)),
              (e.DOMException.prototype.constructor = e.DOMException);
          }
          (E.polyfill = !0),
            self.fetch || ((self.fetch = E), (self.Headers = a), (self.Request = T), (self.Response = g)),
            (e.Headers = a),
            (e.Request = T),
            (e.Response = g),
            (e.fetch = E),
            Object.defineProperty(e, '__esModule', { value: !0 });
        });
      },
      function(e, t, s) {
        'use strict';

        function i(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var n = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          a = s(35),
          r = s(2),
          o = s(6),
          c = (function() {
            function e(t, s, n, a, r, o) {
              i(this, e),
                (this.dm = t),
                (this.url = null),
                (this.timeout = s),
                (this.clientType = a),
                (this.appVersion = r),
                (this.locale = n),
                (this.carrierCode = o),
                (this.interval = null),
                (this.inService = !1),
                (this.timer = null),
                (this.retries = 0),
                (this.maxRetries = 0),
                (this.started = !1),
                (this.isResponseInService = this.isResponseInServiceCB),
                (this.serverDataUpdate = null),
                (this.serverVersion = ''),
                (this.serverTimeDelta = 0),
                (this.serverTimeDeltaMaxDiff = 1e3),
                (this.serverTimeDeltaMinChange = 100);
            }

            return (
              n(e, [
                {
                  key: 'start',
                  value: function(e) {
                    if (!this.started) {
                      return e
                        ? ((this.interval = 0), (this.inService = !0), void (this.started = !0))
                        : void this._doRequest();
                    }
                  },
                },
                {
                  key: 'stop',
                  value: function() {
                    this.interval = 0;
                  },
                },
                {
                  key: 'setInterval',
                  value: function(e) {
                    this.interval = e;
                  },
                },
                {
                  key: 'setUrl',
                  value: function(e) {
                    this.url = e;
                  },
                },
                {
                  key: 'isInService',
                  value: function() {
                    return this.inService;
                  },
                },
                {
                  key: '_doRequest',
                  value: function() {
                    var e = this;
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB.doRequest doHeartbeat start with:[' + this.url + ']');
                    var t = {
                      clientDetail: {
                        location: this.dm.appManager.location,
                        clientID: this.dm.appManager.kioskId,
                        clientTime: new Date(),
                        kmClientID: this.dm.appManager.smKioskId,
                        selectedLanguage: this.locale,
                        clientType: this.clientType,
                        appVersion: this.appVersion,
                        carrierCode: this.carrierCode,
                      },
                    };
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'ETS Heartbeat request: ' + JSON.stringify(t)),
                      (0, a.fetchWithTimeout)(this.url, t, this.timeout, this.dm.dmLog)
                        .then(function(t) {
                          e._heartbeatSuccess(t);
                        })
                        .catch(function(t) {
                          e.dm.dmLog(r.TraceLevels.LOG_ALERT, 'HB.doRequest Catch: ' + t), e._heartbeatFailed(t);
                        });
                  },
                },
                {
                  key: 'onInService',
                  value: function() {
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB.onInService default onInService');
                  },
                },
                {
                  key: 'onOutOfService',
                  value: function() {
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB.onOutOfService default onOutOfService');
                  },
                },
                {
                  key: '_heartbeatSuccess',
                  value: function(e) {
                    var t = this;
                    if (
                      (this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB.heartbeatSuccess json: ' + JSON.stringify(e)),
                      this._updateServerData(e),
                      this.isResponseInService(e))
                    ) {
                      if (((this.retries = 0), !this.inService)) {
                        this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB ->Going into service'),
                          (this.inService = !0),
                          this.dm.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_UP');
                        try {
                          this.onInService(e);
                        } catch (e) {
                          this.dm.dmLog(r.TraceLevels.LOG_ALERT, 'HB -> Error in inService: ' + (0, o.debugObject)(e));
                        }
                      }
                    } else if (this.inService) {
                      if (this.retries < this.maxRetries) {
                        this.retries++,
                          this.dm.dmLog(
                            r.TraceLevels.LOG_TRACE,
                            'HB isResponseInService() false. Number of retries left: ' +
                              (this.maxRetries - this.retries)
                          );
                      } else {
                        this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB isResponseInService() false: Going out of service'),
                          (this.inService = !1),
                          this.dm.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_DOWN');
                        try {
                          this.onOutOfService(e);
                        } catch (e) {
                          this.dm.dmLog(
                            r.TraceLevels.LOG_ALERT,
                            'HB Error in onOutOfService: ' + (0, o.debugObject)(e)
                          );
                        }
                      }
                    } else {
                      this.started || this.dm.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_DOWN');
                    }
                    this.interval > 0 &&
                      (this.timer = setTimeout(function() {
                        t._doRequest();
                      }, this.interval)),
                      (this.started = !0),
                      this.onResponse(e);
                  },
                },
                {
                  key: '_heartbeatFailed',
                  value: function(e) {
                    var t = this;
                    if ((this.dm.dmLog(r.TraceLevels.LOG_ALERT, 'HB.heartbeatFailed...'), this.inService)) {
                      if (this.retries < this.maxRetries) {
                        this.retries++,
                          this.dm.dmLog(
                            r.TraceLevels.LOG_ALERT,
                            'HB ETS response shows not in service. Number of retries left: ' +
                              (this.maxRetries - this.retries)
                          );
                      } else {
                        this.dm.dmLog(
                          r.TraceLevels.LOG_ALERT,
                          'HB ETS response shows not in service: Going out of service'
                        ),
                          (this.inService = !1),
                          this.dm.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_DOWN');
                        try {
                          this.dm.dmLog(r.TraceLevels.LOG_ALERT, 'HB call onOutOfService: ' + JSON.stringify(e)),
                            this.onOutOfService(e);
                        } catch (e) {
                          this.dm.dmLog(
                            r.TraceLevels.LOG_ALERT,
                            'HB Error in onOutOfService: ' + (0, o.debugObject)(e)
                          );
                        }
                      }
                    } else {
                      this.started || this.dm.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_DOWN');
                    }
                    this.interval > 0 &&
                      (this.timer = setTimeout(function() {
                        t._doRequest();
                      }, this.interval)),
                      (this.started = !0);
                  },
                },
                {
                  key: 'setRetries',
                  value: function(e) {
                    this.maxRetries = e;
                  },
                },
                {
                  key: 'onResponse',
                  value: function(e) {},
                },
                {
                  key: 'isResponseInServiceCB',
                  value: function(e) {
                    return !0;
                  },
                },
                {
                  key: '_updateServerData',
                  value: function(e) {
                    var t = e.etsResponse.serverDetail.etsVersion;
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB serverversion: ' + t);
                    var s = e.etsResponse.serverDetail.currentDateTime;
                    this.dm.dmLog(
                      r.TraceLevels.LOG_TRACE,
                      'HB currentDateTime: ' + e.etsResponse.serverDetail.currentDateTime
                    );
                    var i = 0,
                      n = !1;
                    if (null != s) {
                      var a = new Date(),
                        o = a.getTime();
                      i = o - s;
                    }
                    this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB serverTime delta: ' + i),
                      i > this.serverTimeDeltaMaxDiff &&
                        Math.abs(this.serverTimeDelta - i) > this.serverTimeDeltaMinChange &&
                        (this.dm.dmLog(r.TraceLevels.LOG_TRACE, 'HB serverTime delta update: ' + i),
                        (this.serverTimeDelta = i),
                        (n = !0),
                        this.dm.TSDMan && this.dm.TSDMan.updateServerDeltaTime(i)),
                      (this.serverVersion !== t || n) &&
                        ((this.serverVersion = t),
                        null !== this.serverDataUpdate && this.serverDataUpdate(t, s, this.serverTimeDelta));
                  },
                },
                {
                  key: 'setServerTimeDeltaMaxDiff',
                  value: function(e) {
                    this.serverTimeDeltaMaxDiff = e;
                  },
                },
                {
                  key: 'setServerTimeDeltaMinChange',
                  value: function(e) {
                    this.serverTimeDeltaMinChange = e;
                  },
                },
              ]),
              e
            );
          })();
        (t.default = c), (e.exports = t.default);
      },
      function(e, t, s) {
        'use strict';

        function i(e, t) {
          if (!(e instanceof t)) {
            throw new TypeError('Cannot call a class as a function');
          }
        }

        Object.defineProperty(t, '__esModule', { value: !0 });
        var n = (function() {
            function e(e, t) {
              for (var s = 0; s < t.length; s++) {
                var i = t[s];
                (i.enumerable = i.enumerable || !1),
                  (i.configurable = !0),
                  'value' in i && (i.writable = !0),
                  Object.defineProperty(e, i.key, i);
              }
            }

            return function(t, s, i) {
              return s && e(t.prototype, s), i && e(t, i), t;
            };
          })(),
          a = s(2),
          r = s(6),
          o = (function() {
            function e() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
              i(this, e),
                (this.logScreenInteractionEvent = !0),
                (this.logScreenFlowEvent = !0),
                (this.logDeviceInteractionEvent = !0),
                (this.logApplicationStateEvent = !0),
                (this.logBusinessFlowEvent = !0),
                (this.logHostInterfaceEvent = !0),
                (this.OOSevent = t),
                (this.logger = null),
                (this.formatVersion = s),
                (this.maxEventsToBuffer = 1e3),
                (this.eventsBuffer = []),
                (this.startTxn = 0),
                (this.sessionId = ''),
                (this.startSession = 0),
                (this.screenId = ''),
                (this.popupScreenId = ''),
                (this.serverDeltaTime = 0),
                (this.serverDeltaTimePending = 0),
                (this.clearAtStartTxn = !0);
            }

            return (
              n(e, [
                {
                  key: 'setLogger',
                  value: function(e) {
                    (this.logger = e), this.logIt(a.TraceLevels.LOG_TRACE, 'TSD set logger.');
                  },
                },
                {
                  key: 'noLogs',
                  value: function() {
                    (this.logScreenInteractionEvent = !1),
                      (this.logScreenFlowEvent = !1),
                      (this.logDeviceInteractionEvent = !1),
                      (this.logApplicationStateEvent = !1),
                      (this.logBusinessFlowEvent = !1),
                      (this.logHostInterfaceEvent = !1);
                  },
                },
                {
                  key: 'setLogScreenInteractionEvent',
                  value: function(e) {
                    this.logScreenInteractionEvent = e;
                  },
                },
                {
                  key: 'setLogScreenFlowEvent',
                  value: function(e) {
                    this.logScreenFlowEvent = e;
                  },
                },
                {
                  key: 'setLogDeviceInteractionEvent',
                  value: function(e) {
                    this.logDeviceInteractionEvent = e;
                  },
                },
                {
                  key: 'setLogApplicationStateEvent',
                  value: function(e) {
                    this.logApplicationStateEvent = e;
                  },
                },
                {
                  key: 'setLogBusinessFlowEvent',
                  value: function(e) {
                    this.logBusinessFlowEvent = e;
                  },
                },
                {
                  key: 'setLogHostInterfaceEvent',
                  value: function(e) {
                    this.logHostInterfaceEvent = e;
                  },
                },
                {
                  key: 'setClearAtStartTxn',
                  value: function(e) {
                    this.clearAtStartTxn = e;
                  },
                },
                {
                  key: 'clearTxn',
                  value: function(e, t) {
                    if (e) {
                      if (0 !== this.startTxn) {
                        var s = this.eventsBuffer.findIndex(function(e) {
                          return e.eventType === a.AppStateEventType.TXN_START;
                        });
                        s >= 0 &&
                          (this.logIt(a.TraceLevels.LOG_TRACE, ' clearTxn: cleared prev startTxn at index:' + s),
                          (this.eventsBuffer = this.eventsBuffer.filter(function(e, t) {
                            return t > s;
                          })));
                      }
                      var i = 30;
                      if ((!isNaN(t) && (0, r.isInteger)(t) && (i = t), i > 0)) {
                        var n = this.eventsBuffer.length,
                          o = this.getEventTime();
                        (i *= 1e3),
                          (this.eventsBuffer = this.eventsBuffer.filter(function(e) {
                            return o - e.eventTime < i;
                          })),
                          this.logIt(
                            a.TraceLevels.LOG_TRACE,
                            ' clearTxn: cleared old events cnt: ' + (n - this.eventsBuffer.length)
                          );
                      }
                    } else {
                      this.eventsBuffer = [];
                    }
                    (this.startTxn = 0),
                      (this.startSession = 0),
                      (this.sessionId = ''),
                      (this.screenId = ''),
                      (this.popupScreenId = ''),
                      0 !== this.serverDeltaTimePending &&
                        ((this.serverDeltaTime = this.serverDeltaTimePending), (this.serverDeltaTimePending = 0));
                  },
                },
                {
                  key: 'addScrInterEvent',
                  value: function(e, t, s, i, n, r) {
                    if (this.logScreenInteractionEvent && this.checkSpace()) {
                      if (0 === this.formatVersion) {
                        var o = {
                          tsdType: a.TSDTypes.SCREEN_INTERACTION,
                          eventId: e,
                          sessionID: this.sessionId,
                          eventTime: this.getEventTime(),
                          screenID: '' !== this.popupScreenId ? this.popupScreenId : t ? t : this.screenId,
                          xpos: null != i ? i : -1,
                          ypos: null != n ? n : -1,
                        };
                        s && (o.elementID = s),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrInterEvent: ' + JSON.stringify(o)),
                          this.eventsBuffer.push(o);
                      } else if (1 === this.formatVersion) {
                        var c = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          stateData: {
                            eventId: e,
                            screenID: '' !== this.popupScreenId ? this.popupScreenId : t ? t : this.screenId,
                            x: null != i ? i : -1,
                            y: null != n ? n : -1,
                          },
                        };
                        s && (c.stateData.elementID = s),
                          r && (c.stateData.description = r),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrInterEvent2: ' + JSON.stringify(c)),
                          this.eventsBuffer.push(c);
                      } else {
                        var l = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          eventType: a.EventTypeName.SCREEN_INTERACTION_EVENT_DETAILS,
                          stateData: {
                            eventID: e,
                            screenID: '' !== this.popupScreenId ? this.popupScreenId : t ? t : this.screenId,
                            x: null != i ? i : -1,
                            y: null != n ? n : -1,
                          },
                        };
                        s && (l.stateData.elementID = s),
                          r && (l.stateData.description = r),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrInterEventDataAnalytics: ' + JSON.stringify(l)),
                          this.eventsBuffer.push(l);
                      }
                    }
                  },
                },
                {
                  key: 'addDeviceInterEvent',
                  value: function(e, t, s, i, n, r, o, c) {
                    if ((this.logDeviceInteractionEvent && this.checkSpace()) || null !== this.OOSevent) {
                      var l = this.mapCBtoDevEventType(e, i, t);
                      if (!l || !this.logDeviceInteractionEvent) {
                        return;
                      }
                      if (0 === this.formatVersion) {
                        var u = {
                          tsdType: a.TSDTypes.DEVICE_INTERACTION,
                          eventId: l,
                          sessionID: this.sessionId,
                          eventTime: this.getEventTime(),
                          screenID: '' !== this.popupScreenId ? this.popupScreenId : n ? n : this.screenId,
                          deviceName: s,
                        };
                        this.logIt(a.TraceLevels.LOG_LEVEL6, ' addDeviceInterEvent: ' + JSON.stringify(u)),
                          this.eventsBuffer.push(u);
                      } else if (1 === this.formatVersion) {
                        var d = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          stateData: {
                            eventId: e,
                            screenID: '' !== this.popupScreenId ? this.popupScreenId : n ? n : this.screenId,
                            device: { name: s },
                          },
                        };
                        r && (d.stateData.device.type = r),
                          o && (d.stateData.device.version = o),
                          c && (d.stateData.description = c),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addDeviceInterEvent2: ' + JSON.stringify(d)),
                          this.eventsBuffer.push(d);
                      } else {
                        var h = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          eventType: l,
                          stateData: {
                            eventID: e,
                            deviceScreenID: '' !== this.popupScreenId ? this.popupScreenId : n ? n : this.screenId,
                            device: { name: s },
                          },
                        };
                        r && (h.stateData.device.type = r),
                          o && (h.stateData.device.version = o),
                          c && (h.stateData.description = c),
                          this.logIt(
                            a.TraceLevels.LOG_LEVEL6,
                            ' addDeviceInterEventDataAnalytics: ' + JSON.stringify(h)
                          ),
                          this.eventsBuffer.push(h);
                      }
                    }
                  },
                },
                {
                  key: 'addScrFlowEvent',
                  value: function(e, t, s, i, n, r, o) {
                    if (this.logScreenFlowEvent && this.checkSpace()) {
                      if (
                        (e === a.ScreenFlowEventType.LOCAL_TRANSITION || e === a.ScreenFlowEventType.CONTROL_TRANSITION
                          ? (s && (this.screenId = s), (this.popupScreenId = ''))
                          : e === a.ScreenFlowEventType.POPUP_END && (s = null === s ? '' : this.screenId),
                        0 === this.formatVersion)
                      ) {
                        var c = {
                          tsdType: a.TSDTypes.SCREEN_FLOW,
                          eventId: e,
                          sessionID: this.sessionId,
                          eventTime: this.getEventTime(),
                          screenID: '' !== this.popupScreenId ? this.popupScreenId : this.screenId,
                        };
                        s && (c.targetScreenID = s),
                          i && (c.transitionCode = i),
                          void 0 !== n && '' !== n && (c.travelerID = n),
                          void 0 !== r && '' !== r && (c.travelerName = r),
                          void 0 !== o && '' !== o && (c.errorCode = o),
                          e === a.ScreenFlowEventType.POPUP_END
                            ? (this.popupScreenId = '')
                            : e === a.ScreenFlowEventType.POPUP_START
                            ? (this.popupScreenId = s)
                            : (e !== a.ScreenFlowEventType.LOCAL_TRANSITION &&
                                e !== a.ScreenFlowEventType.CONTROL_TRANSITION) ||
                              (this.screenId = s),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrFlowEvent: ' + JSON.stringify(c)),
                          this.eventsBuffer.push(c);
                      } else if (1 === this.formatVersion) {
                        var l = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          stateData: {
                            eventId: e,
                            screenID: '' !== this.popupScreenId ? this.popupScreenId : t ? t : this.screenId,
                            targetScreenID: s ? s : '',
                            transitionCode: i,
                          },
                        };
                        n && (l.stateData.description = n),
                          n || void 0 === o || '' === o || (l.stateData.description = 'ErrorCode=' + o),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrFlowEvent: ' + JSON.stringify(l)),
                          this.eventsBuffer.push(l);
                      } else {
                        var u = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          eventType: a.EventTypeName.SCREEN_FLOW_EVENT_DETAILS,
                          stateData: {
                            eventID: e,
                            screenID: '' !== this.popupScreenId ? this.popupScreenId : t ? t : this.screenId,
                            targetScreenID: s ? s : '',
                            transitionCode: i,
                          },
                        };
                        n && (u.stateData.description = n),
                          n || void 0 === o || '' === o || (u.stateData.description = 'ErrorCode=' + o),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addScrFlowEventDataAnalytics: ' + JSON.stringify(u)),
                          this.eventsBuffer.push(u);
                      }
                    }
                  },
                },
                {
                  key: 'addAppStateEvent',
                  value: function(e, t, s) {
                    if (this.logApplicationStateEvent && this.checkSpace()) {
                      var i = this.getEventTime();
                      e === a.AppStateEventType.TXN_START &&
                        (this.clearAtStartTxn && this.clearTxn(!0), (this.startTxn = i), (this.sessionId = t ? t : ''));
                      var n = this.sessionId ? this.sessionId : '';
                      if (0 === this.formatVersion) {
                        var r = {
                          tsdType: a.TSDTypes.APPLICATION_STATE,
                          eventId: e,
                          sessionID: n,
                          eventTime: i,
                        };
                        this.logIt(a.TraceLevels.LOG_LEVEL6, ' addAppStateEvent: ' + JSON.stringify(r)),
                          this.eventsBuffer.push(r);
                      } else if (1 === this.formatVersion) {
                        var o = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          stateData: { eventId: e },
                        };
                        s && (o.stateData.description = s),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addAppStateEvent2: ' + JSON.stringify(o)),
                          this.eventsBuffer.push(o);
                      } else {
                        var c = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          eventType: a.EventTypeName.APP_STATE_EVENT_DETAILS,
                          stateData: { eventID: e },
                        };
                        s && (c.stateData.description = s),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addAppStateEventDataAnalytics: ' + JSON.stringify(c)),
                          this.eventsBuffer.push(c);
                      }
                    }
                  },
                },
                {
                  key: 'addHostInterfaceEvent',
                  value: function(e, t, s, i) {
                    if (this.logHostInterfaceEvent && this.checkSpace()) {
                      if (0 === this.formatVersion) {
                        var n = {
                          tsdType: a.TSDTypes.HOST_INTERFACE,
                          eventId: e,
                          sessionID: this.sessionId,
                          eventTime: this.getEventTime(),
                          endpointAddress: t,
                        };
                        void 0 !== s && '' !== s && (n.description = s),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addHostInterfaceEvent: ' + JSON.stringify(n)),
                          this.eventsBuffer.push(n);
                      } else if (1 === this.formatVersion) {
                        var r = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          stateData: {
                            eventId: e,
                            endpointAddress: t,
                            serviceName: s,
                          },
                        };
                        void 0 !== i && '' !== i && (r.stateData.message = i),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addHostInterfaceEvent2: ' + JSON.stringify(r)),
                          this.eventsBuffer.push(r);
                      } else {
                        var o = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId,
                          eventType: a.EventTypeName.HOST_INTERFACE_EVENT_DETAILS,
                          stateData: {
                            eventID: e,
                            endpointAddress: t,
                            serviceName: s,
                          },
                        };
                        void 0 !== i && '' !== i && (o.stateData.message = i),
                          this.logIt(
                            a.TraceLevels.LOG_LEVEL6,
                            ' addHostInterfaceEventDataAnalytics: ' + JSON.stringify(o)
                          ),
                          this.eventsBuffer.push(o);
                      }
                    }
                  },
                },
                {
                  key: 'addEnvInfoEvent',
                  value: function(e, t, s, i) {
                    if (this.logApplicationStateEvent && this.checkSpace()) {
                      if (1 === this.formatVersion || 0 === this.formatVersion) {
                        var n = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId ? this.sessionId : '',
                          stateData: {
                            eventId: e,
                            appInfo: { name: t, version: s },
                          },
                        };
                        i && (n.stateData.description = i),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addEnvInfoEvent2: ' + JSON.stringify(n)),
                          this.eventsBuffer.push(n);
                      } else {
                        var r = {
                          eventTime: this.getEventTime(),
                          sessionID: this.sessionId ? this.sessionId : '',
                          eventType: a.EventTypeName.ENVIRONMENT_DETAILS,
                          stateData: {
                            eventID: e,
                            appInfo: { name: t, version: s },
                          },
                        };
                        this.logIt(a.TraceLevels.LOG_LEVEL6, ' addEnvInfoEventDataAnalytics: ' + JSON.stringify(r)),
                          this.eventsBuffer.push(r);
                      }
                    }
                  },
                },
                {
                  key: 'addSessionInfoEvent',
                  value: function(e, t, s, i) {
                    if (this.logApplicationStateEvent && this.checkSpace()) {
                      var n = this.getEventTime();
                      if (
                        (e === a.SessionInfoEventType.SESSION_START &&
                          (this.clearAtStartTxn && this.clearTxn(!0), (this.startSession = n)),
                        1 === this.formatVersion || 0 === this.formatVersion)
                      ) {
                        var r = {
                          eventTime: n,
                          sessionID: this.sessionId ? this.sessionId : '',
                          stateData: {
                            eventId: e,
                            startTime: this.startSession,
                          },
                        };
                        e === a.SessionInfoEventType.SESSION_END && (r.stateData.endTime = n),
                          t && (r.stateData.language = t),
                          s && (r.stateData.sessionData = s),
                          i && (r.stateData.description = i),
                          this.logIt(a.TraceLevels.LOG_LEVEL6, ' addSessionInfoEvent2: ' + JSON.stringify(r)),
                          this.eventsBuffer.push(r);
                      } else {
                        var o = {
                          eventTime: n,
                          sessionID: this.sessionId ? this.sessionId : '',
                          eventType: a.EventTypeName.SESSION_SUMMARY_DETAILS,
                          stateData: {
                            eventID: e,
                            startTime: this.startSession,
                          },
                        };
                        e === a.SessionInfoEventType.SESSION_END && (o.stateData.endTime = n),
                          t && (o.stateData.language = t),
                          s && (o.stateData.sessionData = s),
                          i && (o.stateData.description = i),
                          this.logIt(
                            a.TraceLevels.LOG_LEVEL6,
                            ' addSessionInfoEventDataAnalytics: ' + JSON.stringify(o)
                          ),
                          this.eventsBuffer.push(o);
                      }
                    }
                  },
                },
                {
                  key: 'updateServerDeltaTime',
                  value: function(e) {
                    this.logIt(a.TraceLevels.LOG_TRACE, 'TSD updateServerDeltaTime: ' + e),
                      0 === this.startTxn
                        ? ((this.serverDeltaTime = e), (this.serverDeltaTimePending = 0))
                        : (this.serverDeltaTimePending = e);
                  },
                },
                {
                  key: 'getEventTime',
                  value: function() {
                    var e = new Date().getTime() + this.serverDeltaTime;
                    return 0 === this.formatVersion && 0 !== this.startTxn ? e - this.startTxn : e;
                  },
                },
                {
                  key: 'getEvents',
                  value: function() {
                    return this.eventsBuffer;
                  },
                },
                {
                  key: 'mapCBtoDevEventType',
                  value: function(e, t, s) {
                    var i = '';
                    switch (e) {
                      case 'barcodeInserted':
                      case 'cardInserted':
                      case 'passportInserted':
                      case 'ticketInserted':
                        i = a.DeviceEventType.MEDIA_INSERTED;
                        break;
                      case 'barcodeRemoved':
                      case 'cardRemoved':
                      case 'passportRemoved':
                      case 'ticketRemoved':
                      case 'bagtagRemoved':
                        i = a.DeviceEventType.MEDIA_REMOVED;
                        break;
                      case 'barcodeDamaged':
                      case 'cardDamaged':
                      case 'passportDamaged':
                        i = a.DeviceEventType.MEDIA_DAMAGED;
                        break;
                      case 'dataError':
                        i =
                          a.deviceIds.FACE_TRACKING === s && this.isFatalError(s, t, 'true')
                            ? a.DeviceEventType.OFFLINE
                            : a.DeviceEventType.MEDIA_DAMAGED;
                        break;
                      case 'barcodeReadInternal':
                      case 'barcodeRead':
                      case 'cardReadInternal':
                      case 'cardRead':
                      case 'passportReadInternal':
                      case 'passportRead':
                      case 'ticketRead':
                        i = a.DeviceEventType.DATA_READ;
                        break;
                      case 'getKioskDeviceHelp':
                        i = a.DeviceEventType.HELP_LEVEL_INVOKED;
                        break;
                      case 'headsetInserted':
                        i = a.DeviceEventType.HEADSET_INSERTED;
                        break;
                      case 'headsetRemoved':
                        i = a.DeviceEventType.HEADSET_REMOVED;
                        break;
                      case 'keyPressed':
                        i = a.DeviceEventType.NAVIGATION_KEY_PRESSED;
                        break;
                      case 'pictureTaken':
                        i = a.DeviceEventType.PICTURE_TAKEN;
                        break;
                      case 'faceDescriptor':
                        i = a.DeviceEventType.FACE_DESCRIPTOR;
                        break;
                      case 'ticketPrintingComplete':
                      case 'bagtagPrintingComplete':
                      case 'pagePrintComplete':
                        i = a.DeviceEventType.PRINT_ENDED;
                        break;
                      case 'printerError':
                        this.logIt(a.TraceLevels.LOG_LEVEL6, 'printerError: ' + t),
                          this.isFatalError(s, t, 'true') &&
                            (i =
                              0 === t.indexOf('101,')
                                ? a.DeviceEventType.JAMMED
                                : 0 === t.indexOf('108,')
                                ? a.DeviceEventType.OUT
                                : a.DeviceEventType.OFFLINE);
                        break;
                      case 'statusChange':
                        Array.isArray(t)
                          ? (this.logIt(a.TraceLevels.LOG_LEVEL6, 'TSD statusChange codeId: ' + t),
                            t[1]
                              ? (null !== this.OOSevent && this.OOSevent(s, t[0]), (i = a.DeviceEventType.OFFLINE))
                              : (i = a.DeviceEventType.STATUS_CHANGED))
                          : (i = this.isFatalError(s, t, 'true')
                              ? a.DeviceEventType.OFFLINE
                              : a.DeviceEventType.STATUS_CHANGED);
                        break;
                      case 'statusIsOK':
                        this.isFatalError(s, t, '0') && (i = a.DeviceEventType.OFFLINE);
                        break;
                      case 'ticketEjected':
                      case 'cardEjected':
                        i = a.DeviceEventType.EJECTED;
                        break;
                      case 'pectabLoaded':
                      case 'pectabLoadingComplete':
                        i = a.DeviceEventType.LOADED;
                        break;
                      case 'ticketPresent':
                      case 'bagtagPresent':
                        i = a.DeviceEventType.PRESENT;
                        break;
                      case 'ticketPrinted':
                      case 'bagtagPrinted':
                      case 'pagePrinted':
                        i = a.DeviceEventType.PRINTED;
                        break;
                      case 'passportDataError':
                        i = a.DeviceEventType.DATA_ERROR;
                        break;
                      case 'ticketFailed':
                      case 'bagtagFailed':
                      case 'pagePrintFailed':
                      case 'pectabFailed':
                        i = a.DeviceEventType.FAILED;
                        break;
                      case 'cardInsertedIncomplete':
                        i = a.DeviceEventType.INSERTED_INCOMPLETE;
                        break;
                      case 'accessingRFChip':
                        i = a.DeviceEventType.ACCESSING_RF_CHIP;
                        break;
                      case 'printerTrayStatusChanged':
                        i = a.DeviceEventType.STATUS_CHANGED;
                        break;
                      case 'cardInThroat':
                        i = '';
                        break;
                      case 'getCurrentState':
                      case 'notificationText':
                      case 'isOK':
                      case 'getStatusHeadset':
                      case 'getStatusKeypad':
                      case 'getStatusTTS':
                      case 'isHeadsetAvailable':
                      case 'speechCompleted':
                      case 'speechPaused':
                      case 'speechStarted':
                      case 'speechStopped':
                      case 'isAccessibilitySupported':
                      case 'play':
                      case 'sysmgrCommand':
                      case 'setup':
                      case 'faceAbsent':
                      case 'facePresent':
                      case 'trackingEvent':
                      case 'countDown':
                      case 'analyze':
                      case 'analyzeResult':
                      case 'show':
                      case 'inputChanged':
                      case 'outputChanged':
                      case 'printFileByteStream':
                        break;
                      case a.DeviceEventType.ENABLED:
                      case a.DeviceEventType.DISABLED:
                        i = e;
                        break;
                      default:
                        i = '';
                    }
                    return i;
                  },
                },
                {
                  key: 'isFatalError',
                  value: function(e, t, s) {
                    if (
                      (this.logIt(
                        a.TraceLevels.LOG_TRACE,
                        'TSD isFatalError deviceId: ' + e + ' codeId: ' + t + ' val: ' + s
                      ),
                      t)
                    ) {
                      var i = t.split(',');
                      if ((2 === i.length && i[1].trim() === s) || (3 === i.length && i[2].trim() === s)) {
                        return null !== this.OOSevent && this.OOSevent(e, i[0].trim()), !0;
                      }
                    }
                    return !1;
                  },
                },
                {
                  key: 'checkSpace',
                  value: function() {
                    var e = !0;
                    return (
                      this.maxEventsToBuffer > 0 &&
                        this.eventsBuffer.length >= this.maxEventsToBuffer &&
                        ((e = !1), this.logIt(a.TraceLevels.LOG_ALERT, 'TSD no room to buffer events.')),
                      e
                    );
                  },
                },
                {
                  key: 'logIt',
                  value: function(e, t) {
                    null != this.logger ? this.logger(e, t) : e <= a.TraceLevels.LOG_SECURE && console.log(t);
                  },
                },
              ]),
              e
            );
          })();
        (t.default = o), (e.exports = t.default);
      },
    ]);
  }
});

//# sourceMappingURL=embross-device-manager.js.map
